var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBridgeImg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_41018",
    "data-name": "Group 41018",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 751.13,
    height: 495.81,
    viewBox: "0 0 751.13 495.81",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .cls-1, .cls-16, .cls-18, .cls-19, .cls-9 {\r\n        fill: none;\r\n      }\r\n\r\n      .cls-2 {\r\n        clip-path: url(#clip-path);\r\n      }\r\n\r\n      .cls-3 {\r\n        fill: #4eb2a2;\r\n      }\r\n\r\n      .cls-4 {\r\n        opacity: 0.7;\r\n      }\r\n\r\n      .cls-4, .cls-7 {\r\n        isolation: isolate;\r\n      }\r\n\r\n      .cls-5 {\r\n        clip-path: url(#clip-path-3);\r\n      }\r\n\r\n      .cls-6 {\r\n        fill: #fff;\r\n      }\r\n\r\n      .cls-7 {\r\n        opacity: 0.3;\r\n      }\r\n\r\n      .cls-8 {\r\n        clip-path: url(#clip-path-4);\r\n      }\r\n\r\n      .cls-9 {\r\n        stroke: #000;\r\n      }\r\n\r\n      .cls-18, .cls-19, .cls-9 {\r\n        stroke-miterlimit: 10;\r\n      }\r\n\r\n      .cls-10 {\r\n        clip-path: url(#clip-path-5);\r\n      }\r\n\r\n      .cls-11 {\r\n        clip-path: url(#clip-path-6);\r\n      }\r\n\r\n      .cls-12 {\r\n        clip-path: url(#clip-path-7);\r\n      }\r\n\r\n      .cls-13 {\r\n        clip-path: url(#clip-path-8);\r\n      }\r\n\r\n      .cls-14 {\r\n        opacity: 0.2;\r\n      }\r\n\r\n      .cls-15 {\r\n        clip-path: url(#clip-path-9);\r\n      }\r\n\r\n      .cls-16, .cls-18, .cls-19 {\r\n        stroke: #012d35;\r\n      }\r\n\r\n      .cls-16 {\r\n        stroke-linecap: round;\r\n        stroke-linejoin: round;\r\n      }\r\n\r\n      .cls-17 {\r\n        fill: #012d35;\r\n      }\r\n\r\n      .cls-19 {\r\n        stroke-width: 2px;\r\n      }\r\n\r\n      .cls-20 {\r\n        fill: #c3c3c3;\r\n      }\r\n\r\n      .cls-21 {\r\n        fill: #dedede;\r\n      }\r\n\r\n      .cls-22 {\r\n        fill: #a6a6a6;\r\n      }\r\n    "), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7681",
    "data-name": "Rectangle 7681",
    className: "cls-1",
    width: 751.13,
    height: 495.81
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-3"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7421",
    "data-name": "Rectangle 7421",
    className: "cls-1",
    width: 726.905,
    height: 434.265,
    transform: "translate(15.626 43.08)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-4"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7422",
    "data-name": "Rectangle 7422",
    className: "cls-1",
    width: 140.662,
    height: 30.587,
    transform: "translate(531.392 1.843)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-5"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7423",
    "data-name": "Rectangle 7423",
    className: "cls-1",
    width: 78.873,
    height: 17.435,
    transform: "translate(20.281 79.855)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-6"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7424",
    "data-name": "Rectangle 7424",
    className: "cls-1",
    width: 41.798,
    height: 9.588,
    transform: "translate(687.236 123.462)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-7"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7425",
    "data-name": "Rectangle 7425",
    className: "cls-1",
    width: 66.147,
    height: 14.723,
    transform: "translate(393.418 105.457)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-8"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7426",
    "data-name": "Rectangle 7426",
    className: "cls-1",
    width: 41.798,
    height: 9.588,
    transform: "translate(431.226 48.862)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-9"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7601",
    "data-name": "Rectangle 7601",
    className: "cls-1",
    width: 699.81,
    height: 368.3,
    transform: "translate(26.51 88.2)"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_41017",
    "data-name": "Group 41017",
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_41016",
    "data-name": "Group 41016"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_41015",
    "data-name": "Group 41015",
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_40500",
    "data-name": "Path 40500",
    className: "cls-3",
    d: "M692.93,144.35a213.989,213.989,0,0,0-48.52-54.7c-66.89-52.7-167.03-57.35-245.3-30.54C375.97,67.05,353.88,78.3,334.99,94c-13.73,11.39-25.49,24.93-39.18,36.36-14.38,12-32.16,12.28-50.22,11.29q-39-2.16-77.81-6.6c-22.54-2.57-43.77-6.8-66.1-.57C63.98,145,34.1,177.84,22.52,214.64c-14.5,46.22-4.58,97.13,15.38,141.27,6.91,15.28,15.21,30.2,18.81,46.64,3.74,17.09,11.29,34.54,24,47.24,14.85,14.76,38,19.92,58.09,23.74,38.87,7.4,78.86,3.3,117-6,36-8.75,72.69-23.89,110.57-24.15,42.5-.29,82.91,17.08,124.68,24.93,37.38,7,76.05,6.65,113.46,0,33.94-6.06,71-15.62,95.89-41,65.82-67.06,43.57-179.61,7.26-255.64a265.649,265.649,0,0,0-14.73-27.32"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_40996",
    "data-name": "Group 40996",
    className: "cls-4"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_40995",
    "data-name": "Group 40995"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_40994",
    "data-name": "Group 40994",
    className: "cls-5"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_40501",
    "data-name": "Path 40501",
    className: "cls-6",
    d: "M692.93,144.35a213.989,213.989,0,0,0-48.52-54.7c-66.89-52.7-167.03-57.35-245.3-30.54C375.97,67.05,353.88,78.3,334.99,94c-13.73,11.39-25.49,24.93-39.18,36.36-14.38,12-32.16,12.28-50.22,11.29q-39-2.16-77.81-6.6c-22.54-2.57-43.77-6.8-66.1-.57C63.98,145,34.1,177.84,22.52,214.64c-14.5,46.22-4.58,97.13,15.38,141.27,6.91,15.28,15.21,30.2,18.81,46.64,3.74,17.09,11.29,34.54,24,47.24,14.85,14.76,38,19.92,58.09,23.74,38.87,7.4,78.86,3.3,117-6,36-8.75,72.69-23.89,110.57-24.15,42.5-.29,82.91,17.08,124.68,24.93,37.38,7,76.05,6.65,113.46,0,33.94-6.06,71-15.62,95.89-41,65.82-67.06,43.57-179.61,7.26-255.64a265.649,265.649,0,0,0-14.73-27.32"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_40999",
    "data-name": "Group 40999",
    className: "cls-7"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_40998",
    "data-name": "Group 40998"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_40997",
    "data-name": "Group 40997",
    className: "cls-8"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_40502",
    "data-name": "Path 40502",
    className: "cls-9",
    d: "M642.02,14.04s-7.5-12.35-19.21-11.67-15.79,8.24-19.22,13.73-4.8,2.05-13.72-.69-13,2.06-15.1,6.86-1.37,1.37-9.6,0-8.45,3.54-13.73,6.18c-4.3,2.15-5.22,2.24-10,1-5.93-1.6-7.87-.27-9.24,2.48H671.42s-2.64-11-8.82-13.73S648.19,20.9,642.02,14.04Z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_41002",
    "data-name": "Group 41002",
    className: "cls-7"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_41001",
    "data-name": "Group 41001"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_41000",
    "data-name": "Group 41000",
    className: "cls-10"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_40503",
    "data-name": "Path 40503",
    className: "cls-9",
    d: "M82.19,86.87s-4.2-6.88-10.69-6.5-8.78,4.59-10.69,7.64-2.68,1.15-7.64-.38-7.26,1.15-8.4,3.82-.77.76-5.35,0-4.7,2-7.64,3.44c-2.39,1.19-2.9,1.24-5.55.53-3.3-.9-4.38-.15-5.14,1.37H98.52s-1.46-6.11-4.9-7.63S85.63,90.68,82.19,86.87Z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_41005",
    "data-name": "Group 41005",
    className: "cls-7"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_41004",
    "data-name": "Group 41004"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_41003",
    "data-name": "Group 41003",
    className: "cls-11"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_40504",
    "data-name": "Path 40504",
    className: "cls-9",
    d: "M719.92,127.35s-2.19-3.58-5.57-3.38-4.57,2.39-5.57,4-1.39.59-4-.2a3.22,3.22,0,0,0-4.37,2c-.6,1.39-.4.4-2.79,0s-2.45,1-4,1.79a3,3,0,0,1-2.89.27c-1.72-.46-2.28-.07-2.68.72H728.4s-.76-3.18-2.55-4S721.71,129.3,719.92,127.35Z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_41008",
    "data-name": "Group 41008",
    className: "cls-7"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_41007",
    "data-name": "Group 41007"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_41006",
    "data-name": "Group 41006",
    className: "cls-12"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_40505",
    "data-name": "Path 40505",
    className: "cls-9",
    d: "M445.25,111.39s-3.51-5.74-8.93-5.42-7.33,3.83-8.93,6.38-2.23,1-6.38-.32-6.06,1-7,3.19-.64.63-4.47,0-3.92,1.64-6.38,2.87c-2,1-2.42,1-4.63.44-2.76-.75-3.66-.12-4.3,1.15h64.7s-1.23-5.1-4.1-6.38S448.12,114.58,445.25,111.39Z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_41011",
    "data-name": "Group 41011",
    className: "cls-7"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_41010",
    "data-name": "Group 41010"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_41009",
    "data-name": "Group 41009",
    className: "cls-13"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_40506",
    "data-name": "Path 40506",
    className: "cls-9",
    d: "M463.91,52.75s-2.19-3.58-5.57-3.38-4.58,2.38-5.57,4-1.4.59-4-.2a3.219,3.219,0,0,0-4.38,2c-.59,1.39-.4.39-2.78,0s-2.45,1-4,1.79a3,3,0,0,1-2.89.27c-1.72-.46-2.28-.07-2.68.72h40.35s-.76-3.18-2.55-4S465.7,54.74,463.91,52.75Z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_41014",
    "data-name": "Group 41014",
    className: "cls-14"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_41013",
    "data-name": "Group 41013"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_41012",
    "data-name": "Group 41012",
    className: "cls-15"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_40507",
    "data-name": "Path 40507",
    className: "cls-9",
    d: "M26.51,424.33H58.15V138.22h83.22V274.4h17.88V443.59h20.64V191.04H218.4V88.7h61.9V277.15h23.39V202.18h52.27v16.51h44.7V441.53h17.88V400.95h48.84v39.89h23.38V240.01h79.09V428.46h22.7V165.73h27.51V117.58h13.76V90.07h22.01V268.21h35.76V438.09H719.1"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7427",
    "data-name": "Rectangle 7427",
    className: "cls-9",
    width: 83.22,
    height: 8.94,
    transform: "translate(58.15 129.28)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7428",
    "data-name": "Rectangle 7428",
    className: "cls-9",
    width: 38.75,
    height: 4.53,
    transform: "translate(179.65 191.03)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7429",
    "data-name": "Rectangle 7429",
    className: "cls-9",
    width: 62.08,
    height: 4.4,
    transform: "translate(218.22 88.7)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7430",
    "data-name": "Rectangle 7430",
    className: "cls-9",
    width: 9.04,
    height: 9.34,
    transform: "translate(308.61 192.83)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7431",
    "data-name": "Rectangle 7431",
    className: "cls-9",
    width: 4.52,
    height: 5.42,
    transform: "translate(336.63 196.75)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7432",
    "data-name": "Rectangle 7432",
    className: "cls-9",
    width: 44.85,
    height: 5.48,
    transform: "translate(355.96 218.69)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7433",
    "data-name": "Rectangle 7433",
    className: "cls-9",
    width: 79.08,
    height: 4.09,
    transform: "translate(490.76 235.92)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7434",
    "data-name": "Rectangle 7434",
    className: "cls-9",
    width: 31.34,
    height: 8.14,
    transform: "translate(511.09 227.78)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40508",
    "data-name": "Path 40508",
    className: "cls-9",
    d: "M535.79,228.09v-7.54h22.9v15.07"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40509",
    "data-name": "Path 40509",
    className: "cls-9",
    d: "M384.87,216.44V155.55h72.48V206h24.93V120.18H562.3V223.97h24.94"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40510",
    "data-name": "Path 40510",
    className: "cls-9",
    d: "M332.68,186.28V119.02H283.39"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40511",
    "data-name": "Path 40511",
    className: "cls-9",
    d: "M177.28,203.1H161.04V156.13H145.38"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40512",
    "data-name": "Path 40512",
    className: "cls-9",
    d: "M55.51,190.34H42.17V373"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40513",
    "data-name": "Path 40513",
    className: "cls-9",
    d: "M611.59,156.71V134.68h6.96"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40514",
    "data-name": "Path 40514",
    className: "cls-9",
    d: "M658.56,135.26h24.93v92.19h42.33v106.7"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7435",
    "data-name": "Rectangle 7435",
    className: "cls-9",
    width: 6.22,
    height: 12.18,
    transform: "translate(223.09 101.62)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7436",
    "data-name": "Rectangle 7436",
    className: "cls-9",
    width: 6.22,
    height: 12.18,
    transform: "translate(234.29 101.62)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7437",
    "data-name": "Rectangle 7437",
    className: "cls-9",
    width: 6.22,
    height: 12.18,
    transform: "translate(245.49 101.62)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7438",
    "data-name": "Rectangle 7438",
    className: "cls-9",
    width: 6.22,
    height: 12.18,
    transform: "translate(256.69 101.62)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7439",
    "data-name": "Rectangle 7439",
    className: "cls-9",
    width: 6.22,
    height: 12.18,
    transform: "translate(267.89 101.62)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7440",
    "data-name": "Rectangle 7440",
    className: "cls-9",
    width: 6.22,
    height: 12.18,
    transform: "translate(223.09 122.21)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7441",
    "data-name": "Rectangle 7441",
    className: "cls-9",
    width: 6.22,
    height: 12.18,
    transform: "translate(234.29 122.21)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7442",
    "data-name": "Rectangle 7442",
    className: "cls-9",
    width: 6.22,
    height: 12.18,
    transform: "translate(245.49 122.21)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7443",
    "data-name": "Rectangle 7443",
    className: "cls-9",
    width: 6.22,
    height: 12.18,
    transform: "translate(256.69 122.21)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7444",
    "data-name": "Rectangle 7444",
    className: "cls-9",
    width: 6.22,
    height: 12.18,
    transform: "translate(267.89 122.21)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7445",
    "data-name": "Rectangle 7445",
    className: "cls-9",
    width: 6.22,
    height: 12.18,
    transform: "translate(223.09 142.79)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7446",
    "data-name": "Rectangle 7446",
    className: "cls-9",
    width: 6.22,
    height: 12.18,
    transform: "translate(234.29 142.79)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7447",
    "data-name": "Rectangle 7447",
    className: "cls-9",
    width: 6.22,
    height: 12.18,
    transform: "translate(245.49 142.79)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7448",
    "data-name": "Rectangle 7448",
    className: "cls-9",
    width: 6.22,
    height: 12.18,
    transform: "translate(256.69 142.79)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7449",
    "data-name": "Rectangle 7449",
    className: "cls-9",
    width: 6.22,
    height: 12.18,
    transform: "translate(267.89 142.79)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7450",
    "data-name": "Rectangle 7450",
    className: "cls-9",
    width: 6.22,
    height: 12.18,
    transform: "translate(223.09 163.38)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7451",
    "data-name": "Rectangle 7451",
    className: "cls-9",
    width: 6.22,
    height: 12.18,
    transform: "translate(234.29 163.38)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7452",
    "data-name": "Rectangle 7452",
    className: "cls-9",
    width: 6.22,
    height: 12.18,
    transform: "translate(245.49 163.38)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7453",
    "data-name": "Rectangle 7453",
    className: "cls-9",
    width: 6.22,
    height: 12.18,
    transform: "translate(256.69 163.38)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7454",
    "data-name": "Rectangle 7454",
    className: "cls-9",
    width: 6.22,
    height: 12.18,
    transform: "translate(267.89 163.38)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7455",
    "data-name": "Rectangle 7455",
    className: "cls-9",
    width: 6.22,
    height: 12.18,
    transform: "translate(223.09 183.96)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7456",
    "data-name": "Rectangle 7456",
    className: "cls-9",
    width: 6.22,
    height: 12.18,
    transform: "translate(234.29 183.96)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7457",
    "data-name": "Rectangle 7457",
    className: "cls-9",
    width: 6.22,
    height: 12.18,
    transform: "translate(245.49 183.96)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7458",
    "data-name": "Rectangle 7458",
    className: "cls-9",
    width: 6.22,
    height: 12.18,
    transform: "translate(256.69 183.96)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7459",
    "data-name": "Rectangle 7459",
    className: "cls-9",
    width: 6.22,
    height: 12.18,
    transform: "translate(267.89 183.96)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7460",
    "data-name": "Rectangle 7460",
    className: "cls-9",
    width: 6.22,
    height: 12.18,
    transform: "translate(223.09 204.55)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7461",
    "data-name": "Rectangle 7461",
    className: "cls-9",
    width: 6.22,
    height: 12.18,
    transform: "translate(234.29 204.55)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7462",
    "data-name": "Rectangle 7462",
    className: "cls-9",
    width: 6.22,
    height: 12.18,
    transform: "translate(245.49 204.55)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7463",
    "data-name": "Rectangle 7463",
    className: "cls-9",
    width: 6.22,
    height: 12.18,
    transform: "translate(256.69 204.55)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7464",
    "data-name": "Rectangle 7464",
    className: "cls-9",
    width: 6.22,
    height: 12.18,
    transform: "translate(267.89 204.55)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7465",
    "data-name": "Rectangle 7465",
    className: "cls-9",
    width: 6.22,
    height: 12.18,
    transform: "translate(184.9 204.55)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7466",
    "data-name": "Rectangle 7466",
    className: "cls-9",
    width: 6.22,
    height: 12.18,
    transform: "translate(196.1 204.55)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7467",
    "data-name": "Rectangle 7467",
    className: "cls-9",
    width: 6.22,
    height: 12.18,
    transform: "translate(207.3 204.55)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7468",
    "data-name": "Rectangle 7468",
    className: "cls-9",
    width: 6.22,
    height: 12.18,
    transform: "translate(184.9 224.55)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7469",
    "data-name": "Rectangle 7469",
    className: "cls-9",
    width: 6.22,
    height: 12.18,
    transform: "translate(196.1 224.55)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7470",
    "data-name": "Rectangle 7470",
    className: "cls-9",
    width: 6.22,
    height: 12.18,
    transform: "translate(207.3 224.55)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7471",
    "data-name": "Rectangle 7471",
    className: "cls-9",
    width: 6.22,
    height: 12.18,
    transform: "translate(184.9 244.56)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7472",
    "data-name": "Rectangle 7472",
    className: "cls-9",
    width: 6.22,
    height: 12.18,
    transform: "translate(196.1 244.56)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7473",
    "data-name": "Rectangle 7473",
    className: "cls-9",
    width: 6.22,
    height: 12.18,
    transform: "translate(207.3 244.56)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7474",
    "data-name": "Rectangle 7474",
    className: "cls-9",
    width: 6.22,
    height: 12.18,
    transform: "translate(184.9 264.56)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7475",
    "data-name": "Rectangle 7475",
    className: "cls-9",
    width: 6.22,
    height: 12.18,
    transform: "translate(196.1 264.56)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7476",
    "data-name": "Rectangle 7476",
    className: "cls-9",
    width: 6.22,
    height: 12.18,
    transform: "translate(207.3 264.56)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7477",
    "data-name": "Rectangle 7477",
    className: "cls-9",
    width: 6.22,
    height: 12.18,
    transform: "translate(184.9 284.57)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7478",
    "data-name": "Rectangle 7478",
    className: "cls-9",
    width: 6.22,
    height: 12.18,
    transform: "translate(196.1 284.57)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7479",
    "data-name": "Rectangle 7479",
    className: "cls-9",
    width: 6.22,
    height: 12.18,
    transform: "translate(207.3 284.57)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7480",
    "data-name": "Rectangle 7480",
    className: "cls-9",
    width: 6.22,
    height: 12.18,
    transform: "translate(184.9 304.57)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7481",
    "data-name": "Rectangle 7481",
    className: "cls-9",
    width: 6.22,
    height: 12.18,
    transform: "translate(196.1 304.57)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7482",
    "data-name": "Rectangle 7482",
    className: "cls-9",
    width: 6.22,
    height: 12.18,
    transform: "translate(207.3 304.57)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7483",
    "data-name": "Rectangle 7483",
    className: "cls-9",
    width: 6.22,
    height: 12.18,
    transform: "translate(184.9 324.58)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7484",
    "data-name": "Rectangle 7484",
    className: "cls-9",
    width: 6.22,
    height: 12.18,
    transform: "translate(196.1 324.58)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7485",
    "data-name": "Rectangle 7485",
    className: "cls-9",
    width: 6.22,
    height: 12.18,
    transform: "translate(207.3 324.58)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7486",
    "data-name": "Rectangle 7486",
    className: "cls-9",
    width: 6.22,
    height: 12.18,
    transform: "translate(184.9 344.58)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7487",
    "data-name": "Rectangle 7487",
    className: "cls-9",
    width: 6.22,
    height: 12.18,
    transform: "translate(196.1 344.58)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7488",
    "data-name": "Rectangle 7488",
    className: "cls-9",
    width: 6.22,
    height: 12.18,
    transform: "translate(207.3 344.58)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7489",
    "data-name": "Rectangle 7489",
    className: "cls-9",
    width: 6.22,
    height: 12.18,
    transform: "translate(184.9 364.59)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7490",
    "data-name": "Rectangle 7490",
    className: "cls-9",
    width: 6.22,
    height: 12.18,
    transform: "translate(196.1 364.59)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7491",
    "data-name": "Rectangle 7491",
    className: "cls-9",
    width: 6.22,
    height: 12.18,
    transform: "translate(207.3 364.59)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7492",
    "data-name": "Rectangle 7492",
    className: "cls-9",
    width: 6.22,
    height: 12.18,
    transform: "translate(184.9 384.59)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7493",
    "data-name": "Rectangle 7493",
    className: "cls-9",
    width: 6.22,
    height: 12.18,
    transform: "translate(196.1 384.59)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7494",
    "data-name": "Rectangle 7494",
    className: "cls-9",
    width: 6.22,
    height: 12.18,
    transform: "translate(207.3 384.59)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7495",
    "data-name": "Rectangle 7495",
    className: "cls-9",
    width: 6.22,
    height: 12.18,
    transform: "translate(184.9 404.6)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7496",
    "data-name": "Rectangle 7496",
    className: "cls-9",
    width: 6.22,
    height: 12.18,
    transform: "translate(196.1 404.6)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7497",
    "data-name": "Rectangle 7497",
    className: "cls-9",
    width: 6.22,
    height: 12.18,
    transform: "translate(207.3 404.6)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7498",
    "data-name": "Rectangle 7498",
    className: "cls-9",
    width: 6.22,
    height: 12.18,
    transform: "translate(284.77 286.89)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7499",
    "data-name": "Rectangle 7499",
    className: "cls-9",
    width: 6.22,
    height: 12.18,
    transform: "translate(295.97 286.89)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7500",
    "data-name": "Rectangle 7500",
    className: "cls-9",
    width: 6.22,
    height: 12.18,
    transform: "translate(284.77 306.89)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7501",
    "data-name": "Rectangle 7501",
    className: "cls-9",
    width: 6.22,
    height: 12.18,
    transform: "translate(295.97 306.89)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7502",
    "data-name": "Rectangle 7502",
    className: "cls-9",
    width: 6.22,
    height: 12.18,
    transform: "translate(284.77 326.9)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7503",
    "data-name": "Rectangle 7503",
    className: "cls-9",
    width: 6.22,
    height: 12.18,
    transform: "translate(295.97 326.9)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7504",
    "data-name": "Rectangle 7504",
    className: "cls-9",
    width: 6.22,
    height: 12.18,
    transform: "translate(284.77 346.9)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7505",
    "data-name": "Rectangle 7505",
    className: "cls-9",
    width: 6.22,
    height: 12.18,
    transform: "translate(295.97 346.9)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7506",
    "data-name": "Rectangle 7506",
    className: "cls-9",
    width: 6.22,
    height: 12.18,
    transform: "translate(284.77 366.91)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7507",
    "data-name": "Rectangle 7507",
    className: "cls-9",
    width: 6.22,
    height: 12.18,
    transform: "translate(295.97 366.91)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7508",
    "data-name": "Rectangle 7508",
    className: "cls-9",
    width: 6.22,
    height: 12.18,
    transform: "translate(284.77 386.91)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7509",
    "data-name": "Rectangle 7509",
    className: "cls-9",
    width: 6.22,
    height: 12.18,
    transform: "translate(295.97 386.91)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7510",
    "data-name": "Rectangle 7510",
    className: "cls-9",
    width: 6.22,
    height: 12.18,
    transform: "translate(284.77 406.92)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7511",
    "data-name": "Rectangle 7511",
    className: "cls-9",
    width: 6.22,
    height: 12.18,
    transform: "translate(295.97 406.92)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7512",
    "data-name": "Rectangle 7512",
    className: "cls-9",
    width: 6.22,
    height: 12.18,
    transform: "translate(223.09 225.13)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7513",
    "data-name": "Rectangle 7513",
    className: "cls-9",
    width: 6.22,
    height: 12.18,
    transform: "translate(234.29 225.13)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7514",
    "data-name": "Rectangle 7514",
    className: "cls-9",
    width: 6.22,
    height: 12.18,
    transform: "translate(245.49 225.13)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7515",
    "data-name": "Rectangle 7515",
    className: "cls-9",
    width: 6.22,
    height: 12.18,
    transform: "translate(256.69 225.13)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7516",
    "data-name": "Rectangle 7516",
    className: "cls-9",
    width: 6.22,
    height: 12.18,
    transform: "translate(267.89 225.13)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7517",
    "data-name": "Rectangle 7517",
    className: "cls-9",
    width: 6.22,
    height: 12.18,
    transform: "translate(223.09 245.72)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7518",
    "data-name": "Rectangle 7518",
    className: "cls-9",
    width: 6.22,
    height: 12.18,
    transform: "translate(234.29 245.72)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7519",
    "data-name": "Rectangle 7519",
    className: "cls-9",
    width: 6.22,
    height: 12.18,
    transform: "translate(245.49 245.72)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7520",
    "data-name": "Rectangle 7520",
    className: "cls-9",
    width: 6.22,
    height: 12.18,
    transform: "translate(256.69 245.72)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7521",
    "data-name": "Rectangle 7521",
    className: "cls-9",
    width: 6.22,
    height: 12.18,
    transform: "translate(267.89 245.72)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7522",
    "data-name": "Rectangle 7522",
    className: "cls-9",
    width: 6.22,
    height: 12.18,
    transform: "translate(223.09 266.3)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7523",
    "data-name": "Rectangle 7523",
    className: "cls-9",
    width: 6.22,
    height: 12.18,
    transform: "translate(234.29 266.3)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7524",
    "data-name": "Rectangle 7524",
    className: "cls-9",
    width: 6.22,
    height: 12.18,
    transform: "translate(245.49 266.3)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7525",
    "data-name": "Rectangle 7525",
    className: "cls-9",
    width: 6.22,
    height: 12.18,
    transform: "translate(256.69 266.3)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7526",
    "data-name": "Rectangle 7526",
    className: "cls-9",
    width: 6.22,
    height: 12.18,
    transform: "translate(267.89 266.3)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7527",
    "data-name": "Rectangle 7527",
    className: "cls-9",
    width: 6.22,
    height: 12.18,
    transform: "translate(223.09 286.89)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7528",
    "data-name": "Rectangle 7528",
    className: "cls-9",
    width: 6.22,
    height: 12.18,
    transform: "translate(234.29 286.89)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7529",
    "data-name": "Rectangle 7529",
    className: "cls-9",
    width: 6.22,
    height: 12.18,
    transform: "translate(245.49 286.89)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7530",
    "data-name": "Rectangle 7530",
    className: "cls-9",
    width: 6.22,
    height: 12.18,
    transform: "translate(256.69 286.89)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7531",
    "data-name": "Rectangle 7531",
    className: "cls-9",
    width: 6.22,
    height: 12.18,
    transform: "translate(267.89 286.89)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7532",
    "data-name": "Rectangle 7532",
    className: "cls-9",
    width: 6.22,
    height: 12.18,
    transform: "translate(223.09 307.47)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7533",
    "data-name": "Rectangle 7533",
    className: "cls-9",
    width: 6.22,
    height: 12.18,
    transform: "translate(234.29 307.47)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7534",
    "data-name": "Rectangle 7534",
    className: "cls-9",
    width: 6.22,
    height: 12.18,
    transform: "translate(245.49 307.47)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7535",
    "data-name": "Rectangle 7535",
    className: "cls-9",
    width: 6.22,
    height: 12.18,
    transform: "translate(256.69 307.47)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7536",
    "data-name": "Rectangle 7536",
    className: "cls-9",
    width: 6.22,
    height: 12.18,
    transform: "translate(267.89 307.47)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7537",
    "data-name": "Rectangle 7537",
    className: "cls-9",
    width: 6.22,
    height: 12.18,
    transform: "translate(223.09 328.06)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7538",
    "data-name": "Rectangle 7538",
    className: "cls-9",
    width: 6.22,
    height: 12.18,
    transform: "translate(234.29 328.06)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7539",
    "data-name": "Rectangle 7539",
    className: "cls-9",
    width: 6.22,
    height: 12.18,
    transform: "translate(245.49 328.06)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7540",
    "data-name": "Rectangle 7540",
    className: "cls-9",
    width: 6.22,
    height: 12.18,
    transform: "translate(256.69 328.06)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7541",
    "data-name": "Rectangle 7541",
    className: "cls-9",
    width: 6.22,
    height: 12.18,
    transform: "translate(267.89 328.06)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7542",
    "data-name": "Rectangle 7542",
    className: "cls-9",
    width: 6.22,
    height: 12.18,
    transform: "translate(223.09 348.64)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7543",
    "data-name": "Rectangle 7543",
    className: "cls-9",
    width: 6.22,
    height: 12.18,
    transform: "translate(234.29 348.64)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7544",
    "data-name": "Rectangle 7544",
    className: "cls-9",
    width: 6.22,
    height: 12.18,
    transform: "translate(245.49 348.64)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7545",
    "data-name": "Rectangle 7545",
    className: "cls-9",
    width: 6.22,
    height: 12.18,
    transform: "translate(256.69 348.64)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7546",
    "data-name": "Rectangle 7546",
    className: "cls-9",
    width: 6.22,
    height: 12.18,
    transform: "translate(267.89 348.64)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7547",
    "data-name": "Rectangle 7547",
    className: "cls-9",
    width: 6.22,
    height: 12.18,
    transform: "translate(223.09 369.23)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7548",
    "data-name": "Rectangle 7548",
    className: "cls-9",
    width: 6.22,
    height: 12.18,
    transform: "translate(234.29 369.23)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7549",
    "data-name": "Rectangle 7549",
    className: "cls-9",
    width: 6.22,
    height: 12.18,
    transform: "translate(245.49 369.23)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7550",
    "data-name": "Rectangle 7550",
    className: "cls-9",
    width: 6.22,
    height: 12.18,
    transform: "translate(256.69 369.23)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7551",
    "data-name": "Rectangle 7551",
    className: "cls-9",
    width: 6.22,
    height: 12.18,
    transform: "translate(267.89 369.23)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7552",
    "data-name": "Rectangle 7552",
    className: "cls-9",
    width: 6.22,
    height: 12.18,
    transform: "translate(223.09 389.81)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7553",
    "data-name": "Rectangle 7553",
    className: "cls-9",
    width: 6.22,
    height: 12.18,
    transform: "translate(234.29 389.81)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7554",
    "data-name": "Rectangle 7554",
    className: "cls-9",
    width: 6.22,
    height: 12.18,
    transform: "translate(245.49 389.81)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7555",
    "data-name": "Rectangle 7555",
    className: "cls-9",
    width: 6.22,
    height: 12.18,
    transform: "translate(256.69 389.81)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7556",
    "data-name": "Rectangle 7556",
    className: "cls-9",
    width: 6.22,
    height: 12.18,
    transform: "translate(267.89 389.81)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7557",
    "data-name": "Rectangle 7557",
    className: "cls-9",
    width: 6.22,
    height: 12.18,
    transform: "translate(223.09 410.98)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7558",
    "data-name": "Rectangle 7558",
    className: "cls-9",
    width: 6.22,
    height: 12.18,
    transform: "translate(234.29 410.98)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7559",
    "data-name": "Rectangle 7559",
    className: "cls-9",
    width: 6.22,
    height: 12.18,
    transform: "translate(245.49 410.98)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7560",
    "data-name": "Rectangle 7560",
    className: "cls-9",
    width: 6.22,
    height: 12.18,
    transform: "translate(256.69 410.98)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7561",
    "data-name": "Rectangle 7561",
    className: "cls-9",
    width: 6.22,
    height: 12.18,
    transform: "translate(267.89 410.98)"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_23",
    "data-name": "Line 23",
    className: "cls-9",
    y2: 248.18,
    transform: "translate(218.4 195.56)"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_24",
    "data-name": "Line 24",
    className: "cls-9",
    y2: 233.1,
    transform: "translate(313.54 207.16)"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_25",
    "data-name": "Line 25",
    className: "cls-9",
    y2: 233.1,
    transform: "translate(325.72 207.16)"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_26",
    "data-name": "Line 26",
    className: "cls-9",
    y2: 233.1,
    transform: "translate(337.9 207.16)"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_27",
    "data-name": "Line 27",
    className: "cls-9",
    y2: 233.1,
    transform: "translate(350.07 207.16)"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_28",
    "data-name": "Line 28",
    className: "cls-9",
    y2: 209.91,
    transform: "translate(362.25 230.35)"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_29",
    "data-name": "Line 29",
    className: "cls-9",
    y2: 209.91,
    transform: "translate(374.43 230.35)"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_30",
    "data-name": "Line 30",
    className: "cls-9",
    y2: 209.91,
    transform: "translate(386.61 230.35)"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_31",
    "data-name": "Line 31",
    className: "cls-9",
    x2: 75.96,
    transform: "translate(61.31 151.49)"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_32",
    "data-name": "Line 32",
    className: "cls-9",
    x2: 75.96,
    transform: "translate(61.31 166.57)"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_33",
    "data-name": "Line 33",
    className: "cls-9",
    x2: 75.96,
    transform: "translate(61.31 181.64)"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_34",
    "data-name": "Line 34",
    className: "cls-9",
    x2: 75.96,
    transform: "translate(61.31 196.72)"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_35",
    "data-name": "Line 35",
    className: "cls-9",
    x2: 75.96,
    transform: "translate(61.31 211.8)"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_36",
    "data-name": "Line 36",
    className: "cls-9",
    x2: 75.96,
    transform: "translate(61.31 226.87)"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_37",
    "data-name": "Line 37",
    className: "cls-9",
    x2: 75.96,
    transform: "translate(61.31 241.95)"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_38",
    "data-name": "Line 38",
    className: "cls-9",
    x2: 75.96,
    transform: "translate(61.31 257.03)"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_39",
    "data-name": "Line 39",
    className: "cls-9",
    x2: 75.96,
    transform: "translate(61.31 272.1)"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_40",
    "data-name": "Line 40",
    className: "cls-9",
    x2: 75.96,
    transform: "translate(61.31 287.18)"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_41",
    "data-name": "Line 41",
    className: "cls-9",
    x2: 75.96,
    transform: "translate(61.31 302.26)"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_42",
    "data-name": "Line 42",
    className: "cls-9",
    x2: 75.96,
    transform: "translate(61.31 317.33)"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_43",
    "data-name": "Line 43",
    className: "cls-9",
    x2: 75.96,
    transform: "translate(61.31 332.41)"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_44",
    "data-name": "Line 44",
    className: "cls-9",
    x2: 75.96,
    transform: "translate(61.31 347.48)"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_45",
    "data-name": "Line 45",
    className: "cls-9",
    x2: 75.96,
    transform: "translate(61.31 362.56)"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_46",
    "data-name": "Line 46",
    className: "cls-9",
    x2: 75.96,
    transform: "translate(61.31 377.64)"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_47",
    "data-name": "Line 47",
    className: "cls-9",
    x2: 75.96,
    transform: "translate(61.31 392.71)"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_48",
    "data-name": "Line 48",
    className: "cls-9",
    x2: 75.96,
    transform: "translate(61.31 407.79)"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_49",
    "data-name": "Line 49",
    className: "cls-9",
    x2: 75.96,
    transform: "translate(61.31 422.87)"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_50",
    "data-name": "Line 50",
    className: "cls-9",
    x2: 75.96,
    transform: "translate(61.31 437.94)"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_51",
    "data-name": "Line 51",
    className: "cls-9",
    x2: 75.96,
    transform: "translate(61.31 453.02)"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_52",
    "data-name": "Line 52",
    className: "cls-9",
    y2: 327.62,
    transform: "translate(71.16 128.88)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40515",
    "data-name": "Path 40515",
    className: "cls-9",
    d: "M593.03,193.24h16.82v8.12H593.03"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40516",
    "data-name": "Path 40516",
    className: "cls-9",
    d: "M691.03,284.28H671.9v8.12h19.13"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40517",
    "data-name": "Path 40517",
    className: "cls-9",
    d: "M691.03,303.42H671.9v8.11h19.13"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40518",
    "data-name": "Path 40518",
    className: "cls-9",
    d: "M691.03,322.55H671.9v8.12h19.13"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40519",
    "data-name": "Path 40519",
    className: "cls-9",
    d: "M691.03,341.68H671.9v8.12h19.13"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40520",
    "data-name": "Path 40520",
    className: "cls-9",
    d: "M691.03,360.82H671.9v8.12h19.13"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40521",
    "data-name": "Path 40521",
    className: "cls-9",
    d: "M691.03,379.96H671.9v8.11h19.13"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40522",
    "data-name": "Path 40522",
    className: "cls-9",
    d: "M691.03,399.09H671.9v8.12h19.13"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40523",
    "data-name": "Path 40523",
    className: "cls-9",
    d: "M691.03,418.23H671.9v8.12h19.13"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40524",
    "data-name": "Path 40524",
    className: "cls-9",
    d: "M593.03,215.28h16.82v8.11H593.03"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40525",
    "data-name": "Path 40525",
    className: "cls-9",
    d: "M593.03,237.31h16.82v8.12H593.03"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40526",
    "data-name": "Path 40526",
    className: "cls-9",
    d: "M593.03,259.35h16.82v8.11H593.03"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40527",
    "data-name": "Path 40527",
    className: "cls-9",
    d: "M593.03,281.38h16.82v8.12H593.03"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40528",
    "data-name": "Path 40528",
    className: "cls-9",
    d: "M593.03,303.42h16.82v8.11H593.03"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40529",
    "data-name": "Path 40529",
    className: "cls-9",
    d: "M593.03,325.45h16.82v8.12H593.03"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40530",
    "data-name": "Path 40530",
    className: "cls-9",
    d: "M593.03,347.48h16.82v8.12H593.03"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40531",
    "data-name": "Path 40531",
    className: "cls-9",
    d: "M593.03,369.52h16.82v8.12H593.03"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40532",
    "data-name": "Path 40532",
    className: "cls-9",
    d: "M593.03,391.55h16.82v8.12H593.03"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7562",
    "data-name": "Rectangle 7562",
    className: "cls-9",
    width: 73.06,
    height: 6.96,
    transform: "translate(493.3 246.01)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7563",
    "data-name": "Rectangle 7563",
    className: "cls-9",
    width: 73.06,
    height: 6.96,
    transform: "translate(493.3 258.19)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7564",
    "data-name": "Rectangle 7564",
    className: "cls-9",
    width: 73.06,
    height: 6.96,
    transform: "translate(493.3 270.36)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7565",
    "data-name": "Rectangle 7565",
    className: "cls-9",
    width: 73.06,
    height: 6.96,
    transform: "translate(493.3 282.54)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7566",
    "data-name": "Rectangle 7566",
    className: "cls-9",
    width: 73.06,
    height: 6.96,
    transform: "translate(493.3 294.72)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7567",
    "data-name": "Rectangle 7567",
    className: "cls-9",
    width: 73.06,
    height: 6.96,
    transform: "translate(493.3 306.89)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7568",
    "data-name": "Rectangle 7568",
    className: "cls-9",
    width: 73.06,
    height: 6.96,
    transform: "translate(493.3 319.07)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7569",
    "data-name": "Rectangle 7569",
    className: "cls-9",
    width: 73.06,
    height: 6.96,
    transform: "translate(493.3 331.25)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7570",
    "data-name": "Rectangle 7570",
    className: "cls-9",
    width: 73.06,
    height: 6.96,
    transform: "translate(493.3 343.43)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7571",
    "data-name": "Rectangle 7571",
    className: "cls-9",
    width: 73.06,
    height: 6.96,
    transform: "translate(493.3 355.6)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7572",
    "data-name": "Rectangle 7572",
    className: "cls-9",
    width: 73.06,
    height: 6.96,
    transform: "translate(493.3 367.78)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7573",
    "data-name": "Rectangle 7573",
    className: "cls-9",
    width: 73.06,
    height: 6.96,
    transform: "translate(493.3 379.96)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7574",
    "data-name": "Rectangle 7574",
    className: "cls-9",
    width: 73.06,
    height: 6.96,
    transform: "translate(493.3 392.13)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7575",
    "data-name": "Rectangle 7575",
    className: "cls-9",
    width: 73.06,
    height: 6.96,
    transform: "translate(493.3 404.31)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7576",
    "data-name": "Rectangle 7576",
    className: "cls-9",
    width: 73.06,
    height: 6.96,
    transform: "translate(493.3 416.49)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7577",
    "data-name": "Rectangle 7577",
    className: "cls-9",
    width: 73.06,
    height: 6.96,
    transform: "translate(493.3 428.66)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7578",
    "data-name": "Rectangle 7578",
    className: "cls-9",
    width: 73.06,
    height: 6.96,
    transform: "translate(493.3 440.84)"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_53",
    "data-name": "Line 53",
    className: "cls-9",
    y2: 269.05,
    transform: "translate(620.29 174.11)"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_54",
    "data-name": "Line 54",
    className: "cls-9",
    y2: 320.08,
    transform: "translate(635.36 123.08)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7579",
    "data-name": "Rectangle 7579",
    className: "cls-9",
    width: 36.53,
    height: 19.14,
    transform: "translate(425.46 381.7)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7580",
    "data-name": "Rectangle 7580",
    className: "cls-9",
    width: 19.14,
    height: 33.63,
    transform: "translate(434.15 348.06)"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_55",
    "data-name": "Line 55",
    className: "cls-9",
    y2: 166.13,
    transform: "translate(280.3 277.15)"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_56",
    "data-name": "Line 56",
    className: "cls-9",
    x1: 88.71,
    transform: "translate(401.42 258.94)"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_57",
    "data-name": "Line 57",
    className: "cls-9",
    x1: 88.71,
    transform: "translate(401.42 268.85)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7581",
    "data-name": "Rectangle 7581",
    className: "cls-9",
    width: 13.53,
    height: 9.91,
    transform: "translate(405.38 276.28)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7582",
    "data-name": "Rectangle 7582",
    className: "cls-9",
    width: 13.53,
    height: 9.91,
    transform: "translate(422.07 276.28)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7583",
    "data-name": "Rectangle 7583",
    className: "cls-9",
    width: 13.53,
    height: 9.91,
    transform: "translate(438.76 276.28)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7584",
    "data-name": "Rectangle 7584",
    className: "cls-9",
    width: 13.53,
    height: 9.91,
    transform: "translate(455.45 276.28)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7585",
    "data-name": "Rectangle 7585",
    className: "cls-9",
    width: 13.53,
    height: 9.91,
    transform: "translate(472.14 276.28)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7586",
    "data-name": "Rectangle 7586",
    className: "cls-9",
    width: 13.53,
    height: 9.91,
    transform: "translate(405.38 291.65)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7587",
    "data-name": "Rectangle 7587",
    className: "cls-9",
    width: 13.53,
    height: 9.91,
    transform: "translate(422.07 291.65)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7588",
    "data-name": "Rectangle 7588",
    className: "cls-9",
    width: 13.53,
    height: 9.91,
    transform: "translate(438.76 291.65)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7589",
    "data-name": "Rectangle 7589",
    className: "cls-9",
    width: 13.53,
    height: 9.91,
    transform: "translate(455.45 291.65)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7590",
    "data-name": "Rectangle 7590",
    className: "cls-9",
    width: 13.53,
    height: 9.91,
    transform: "translate(472.14 291.65)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7591",
    "data-name": "Rectangle 7591",
    className: "cls-9",
    width: 13.53,
    height: 9.91,
    transform: "translate(405.38 307.01)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7592",
    "data-name": "Rectangle 7592",
    className: "cls-9",
    width: 13.53,
    height: 9.91,
    transform: "translate(422.07 307.01)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7593",
    "data-name": "Rectangle 7593",
    className: "cls-9",
    width: 13.53,
    height: 9.91,
    transform: "translate(438.76 307.01)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7594",
    "data-name": "Rectangle 7594",
    className: "cls-9",
    width: 13.53,
    height: 9.91,
    transform: "translate(455.45 307.01)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7595",
    "data-name": "Rectangle 7595",
    className: "cls-9",
    width: 13.53,
    height: 9.91,
    transform: "translate(472.14 307.01)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7596",
    "data-name": "Rectangle 7596",
    className: "cls-9",
    width: 13.53,
    height: 9.91,
    transform: "translate(405.38 334.76)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7597",
    "data-name": "Rectangle 7597",
    className: "cls-9",
    width: 13.53,
    height: 9.91,
    transform: "translate(422.07 334.76)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7598",
    "data-name": "Rectangle 7598",
    className: "cls-9",
    width: 13.53,
    height: 9.91,
    transform: "translate(438.76 334.76)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7599",
    "data-name": "Rectangle 7599",
    className: "cls-9",
    width: 13.53,
    height: 9.91,
    transform: "translate(455.45 334.76)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7600",
    "data-name": "Rectangle 7600",
    className: "cls-9",
    width: 13.53,
    height: 9.91,
    transform: "translate(472.14 334.76)"
  })))), /*#__PURE__*/React.createElement("line", {
    id: "Line_58",
    "data-name": "Line 58",
    className: "cls-16",
    y1: 64.79,
    x2: 16.68,
    transform: "translate(229.44 1.17)"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_59",
    "data-name": "Line 59",
    className: "cls-16",
    x1: 16.67,
    y1: 64.79,
    transform: "translate(268.82 1.17)"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_60",
    "data-name": "Line 60",
    className: "cls-16",
    y1: 62.79,
    transform: "translate(257.7 0.5)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40533",
    "data-name": "Path 40533",
    className: "cls-16",
    d: "M271.46,11.7H243.47l14.32-6.42Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40534",
    "data-name": "Path 40534",
    className: "cls-16",
    d: "M271.46,11.91H243.47l14.32,6.41Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40535",
    "data-name": "Path 40535",
    className: "cls-16",
    d: "M275.09,24.89H239.83l18.04-6.42Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40536",
    "data-name": "Path 40536",
    className: "cls-16",
    d: "M275.09,25.09H239.83l18.04,6.41Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40537",
    "data-name": "Path 40537",
    className: "cls-16",
    d: "M278.28,38.07H236.65l21.3-6.41Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40538",
    "data-name": "Path 40538",
    className: "cls-16",
    d: "M278.28,38.28H236.65l21.3,6.41Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40539",
    "data-name": "Path 40539",
    className: "cls-16",
    d: "M281.69,51.26H233.24l24.79-6.41Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40540",
    "data-name": "Path 40540",
    className: "cls-16",
    d: "M281.69,51.47H233.24l24.79,6.41Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40541",
    "data-name": "Path 40541",
    className: "cls-17",
    d: "M295.43,147.82h-2.16v23.79l-.92.92-14.95-15,14.42-14.42h-4.24l-12.3,12.3-12.3-12.3h-4.25l14.42,14.42-17.19,17.19-13.93-13.93L255.6,147.3l-2.08-2.17-13.57,13.58-15.56-15.56h-4.24l17.67,17.68-14.95,14.95-.87-.87V147.82h-5V495.15h5v-8.64l9.26,9.26h4.24l-11.53-11.53,15-14.95,14.95,14.95-11.6,11.53h4.2l9.4-9.41,9.41,9.41h4.24l-11.52-11.53,14.99-14.94,15,14.95-11.52,11.52h4.24l9.41-9.41,3.15,3.16v5.63h5.2V147.82Zm-20.15,11.87,14.95,15-17.19,17.19-14.95-14.95Zm-51.35,153.8,15-15,14.95,15-14.95,14.95Zm29.91,34.15-14.95,15-15-15,15-15ZM223.93,279.3l15-15,14.95,15-14.99,15Zm0-34.15,15-15,14.95,15L238.93,260.1Zm12.84,17.15-14.81,14.81V247.46Zm0,34.15-14.81,14.81V281.61Zm0,34.15-14.81,14.81V315.76Zm0,34.15-14.81,14.81V349.91Zm-12.84,17.08,15-14.95,14.95,14.95-14.95,14.95Zm12.84,17.08-14.81,14.8V384.06Zm19.19-15,15,15-15,14.95-14.95-14.95Zm-14.95-19.2,14.95-15,15,15-15,15Zm0-34.15,14.95-14.95,15,14.95-15,15Zm0-34.15,14.95-14.95,15,14.95-15,15Zm0-34.15,14.95-14.96,15,14.95-15,15Zm0-34.15,14.95-14.95,15,14.95-15,15Zm-2.12-2.12-15-14.95,15-15,14.95,15Zm-2.12,2.12-14.81,14.81V213.3Zm-14.81,190.1,14.81,14.81-14.81,14.8Zm2-2.27,15-14.95,14.95,14.95-14.95,15Zm32,2.12,15,15-15,14.95-14.95-14.95Zm2.13-2.12,14.95-14.95,15,14.95-15,15Zm0-34.15,14.95-14.95,15,14.95-15,14.95Zm0-34.15,14.95-15,15,15-15,15Zm0-34.15,14.95-15,15,15-15,14.95Zm0-34.15,14.95-15,15,15-15,14.95Zm0-34.15,14.95-15,15,15-15,14.95Zm0-34.15,14.95-15,15,15-15,14.95Zm12.83-17.08-15,15-14.95-15,14.95-14.95Zm-31-31,13.93,13.94L238.9,191.85,224.95,177.9Zm-17.08,17.07,13.94,13.94-14.81,14.8V180.89Zm-.87,302V452.36l14.81,14.81Zm2-31.88,15-15,14.95,15-14.95,15Zm32,32L241.02,467.2l14.95-15,15,15Zm2.13-32,14.95-15,15,15-15,15Zm35.17,35.15-1-1,1-1Zm0-6.31-3.15,3.15-15-14.95,14.95-15,3.16,3.16Zm0-27.84-1-1,1-1Zm0-6.32-3.16,3.16-14.95-14.95,15-15,3.15,3.16Zm0-27.83-1-1,1-1Zm0-6.32-3.15,3.16-15-14.95,14.95-15,3.16,3.16Zm0-27.83-1-1,1-1Zm0-6.32-3.16,3.16-14.95-15,15-15,3.15,3.16Zm0-27.84-1-1,1-1Zm0-6.31-3.15,3.16-15-15,14.95-14.95,3.16,3.16Zm0-27.84-1-1,1-1Zm0-6.31-3.16,3.16-14.95-15,14.95-14.95,3.16,3.16Zm0-27.84-1-1,1-1Zm0-6.31-3.16,3.16-14.95-15,15-14.95,3.15,3.15Zm0-27.84-1-1,1-1Zm0-6.31-3.15,3.16-15-15,15-14.95,3.15,3.15Zm0-27.84-1-1,1-1Zm0-6.31-3.15,3.16-15-15,17.19-17.19.92.92Z"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7602",
    "data-name": "Rectangle 7602",
    className: "cls-3",
    width: 148.59,
    height: 29.08,
    transform: "translate(375.94 261.67)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7603",
    "data-name": "Rectangle 7603",
    className: "cls-18",
    width: 148.59,
    height: 29.08,
    transform: "translate(375.94 261.67)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7604",
    "data-name": "Rectangle 7604",
    className: "cls-6",
    width: 13.21,
    height: 22.69,
    transform: "translate(375.93 238.98)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7605",
    "data-name": "Rectangle 7605",
    className: "cls-18",
    width: 13.21,
    height: 22.69,
    transform: "translate(375.93 238.98)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7606",
    "data-name": "Rectangle 7606",
    className: "cls-17",
    width: 13.21,
    height: 5.31,
    transform: "translate(375.93 256.36)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7607",
    "data-name": "Rectangle 7607",
    className: "cls-18",
    width: 13.21,
    height: 5.31,
    transform: "translate(375.93 256.36)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40542",
    "data-name": "Path 40542",
    className: "cls-17",
    d: "M389.15,245.46l-13.22,13.21v3h1.87l11.35-11.35Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40543",
    "data-name": "Path 40543",
    className: "cls-17",
    d: "M389.15,242.45v-3.47h-1.4l-11.82,11.81v4.87Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40544",
    "data-name": "Path 40544",
    className: "cls-17",
    d: "M379.87,238.98l-3.94,3.94v4.86l8.8-8.8Z"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_61",
    "data-name": "Line 61",
    className: "cls-18",
    y1: 157.13,
    transform: "translate(382.54 81.85)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7608",
    "data-name": "Rectangle 7608",
    className: "cls-17",
    width: 5.51,
    height: 4.23,
    transform: "translate(379.87 234.75)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7609",
    "data-name": "Rectangle 7609",
    className: "cls-6",
    width: 13.21,
    height: 22.69,
    transform: "translate(511.32 238.98)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7610",
    "data-name": "Rectangle 7610",
    className: "cls-18",
    width: 13.21,
    height: 22.69,
    transform: "translate(511.32 238.98)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7611",
    "data-name": "Rectangle 7611",
    className: "cls-17",
    width: 13.21,
    height: 5.31,
    transform: "translate(511.32 256.36)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7612",
    "data-name": "Rectangle 7612",
    className: "cls-18",
    width: 13.21,
    height: 5.31,
    transform: "translate(511.32 256.36)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40545",
    "data-name": "Path 40545",
    className: "cls-17",
    d: "M524.53,245.46l-13.21,13.21v3h1.86l11.35-11.35Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40546",
    "data-name": "Path 40546",
    className: "cls-17",
    d: "M524.53,242.45v-3.47h-1.4l-11.81,11.81v4.87Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40547",
    "data-name": "Path 40547",
    className: "cls-17",
    d: "M515.25,238.98l-3.93,3.94v4.86l8.79-8.8Z"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_62",
    "data-name": "Line 62",
    className: "cls-18",
    y1: 157.13,
    transform: "translate(517.92 81.85)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7613",
    "data-name": "Rectangle 7613",
    className: "cls-17",
    width: 5.51,
    height: 4.23,
    transform: "translate(515.25 234.75)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40548",
    "data-name": "Path 40548",
    className: "cls-19",
    d: "M297.04,41.47,279.86,60.58h34.36Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40549",
    "data-name": "Path 40549",
    className: "cls-19",
    d: "M330.4,41.47,313.22,60.58h34.36Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40550",
    "data-name": "Path 40550",
    className: "cls-19",
    d: "M363.77,41.47,346.59,60.58h34.35Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40551",
    "data-name": "Path 40551",
    className: "cls-19",
    d: "M397.13,41.47,379.95,60.58h34.36Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40552",
    "data-name": "Path 40552",
    className: "cls-19",
    d: "M430.49,41.47,413.31,60.58h34.36Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40553",
    "data-name": "Path 40553",
    className: "cls-19",
    d: "M463.85,41.47,446.68,60.58h34.35Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40554",
    "data-name": "Path 40554",
    className: "cls-19",
    d: "M497.22,41.47,480.04,60.58h34.35Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40555",
    "data-name": "Path 40555",
    className: "cls-19",
    d: "M530.58,41.47,513.4,60.58h34.36Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40556",
    "data-name": "Path 40556",
    className: "cls-19",
    d: "M563.94,41.47,546.77,60.58h34.35Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40557",
    "data-name": "Path 40557",
    className: "cls-19",
    d: "M597.31,41.47,580.13,60.58h34.35Z"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_63",
    "data-name": "Line 63",
    className: "cls-19",
    x1: 300.27,
    transform: "translate(297.04 41.47)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40558",
    "data-name": "Path 40558",
    className: "cls-17",
    d: "M395.07,83.73H369.93l-2.52-15.09h30.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40559",
    "data-name": "Path 40559",
    className: "cls-18",
    d: "M395.07,83.73H369.93l-2.52-15.09h30.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40560",
    "data-name": "Path 40560",
    className: "cls-17",
    d: "M530.3,83.73H505.16l-2.51-15.09h30.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40561",
    "data-name": "Path 40561",
    className: "cls-18",
    d: "M530.3,83.73H505.16l-2.51-15.09h30.17Z"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7614",
    "data-name": "Rectangle 7614",
    className: "cls-3",
    width: 18.8,
    height: 19.1,
    transform: "translate(211.72 110.07)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7615",
    "data-name": "Rectangle 7615",
    className: "cls-18",
    width: 18.8,
    height: 19.1,
    transform: "translate(211.72 110.07)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7616",
    "data-name": "Rectangle 7616",
    className: "cls-3",
    width: 59.77,
    height: 60.75,
    transform: "translate(227.58 68.42)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7617",
    "data-name": "Rectangle 7617",
    className: "cls-18",
    width: 59.77,
    height: 60.75,
    transform: "translate(227.58 68.42)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7618",
    "data-name": "Rectangle 7618",
    className: "cls-6",
    width: 38.44,
    height: 31.99,
    transform: "translate(248.91 68.42)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7619",
    "data-name": "Rectangle 7619",
    className: "cls-18",
    width: 38.44,
    height: 31.99,
    transform: "translate(248.91 68.42)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40562",
    "data-name": "Path 40562",
    className: "cls-3",
    d: "M285.76,134.16H229.07l-1.49-4.98h59.67Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40563",
    "data-name": "Path 40563",
    className: "cls-18",
    d: "M285.76,134.16H229.07l-1.49-4.98h59.67Z"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7620",
    "data-name": "Rectangle 7620",
    className: "cls-3",
    width: 47.35,
    height: 2.95,
    transform: "translate(233.81 137.04)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7621",
    "data-name": "Rectangle 7621",
    className: "cls-18",
    width: 47.35,
    height: 2.95,
    transform: "translate(233.81 137.04)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7622",
    "data-name": "Rectangle 7622",
    className: "cls-3",
    width: 52.71,
    height: 2.95,
    transform: "translate(231.13 134.16)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7623",
    "data-name": "Rectangle 7623",
    className: "cls-18",
    width: 52.71,
    height: 2.95,
    transform: "translate(231.13 134.16)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7624",
    "data-name": "Rectangle 7624",
    className: "cls-3",
    width: 91.18,
    height: 8.56,
    transform: "translate(211.45 139.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7625",
    "data-name": "Rectangle 7625",
    className: "cls-18",
    width: 91.18,
    height: 8.56,
    transform: "translate(211.45 139.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7626",
    "data-name": "Rectangle 7626",
    className: "cls-3",
    width: 485.88,
    height: 8.14,
    transform: "translate(144.88 60.56)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7627",
    "data-name": "Rectangle 7627",
    className: "cls-18",
    width: 485.88,
    height: 8.14,
    transform: "translate(144.88 60.56)"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_64",
    "data-name": "Line 64",
    className: "cls-18",
    x1: 93.25,
    y1: 38.9,
    transform: "translate(386.21 1.74)"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_65",
    "data-name": "Line 65",
    className: "cls-18",
    y1: 38.9,
    x2: 93.25,
    transform: "translate(117.6 1.74)"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_66",
    "data-name": "Line 66",
    className: "cls-18",
    y1: 38.9,
    x2: 80.95,
    transform: "translate(140.23 1.74)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40564",
    "data-name": "Path 40564",
    className: "cls-17",
    d: "M311.01,68.7h17.28l8.14-8.14H319.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40565",
    "data-name": "Path 40565",
    className: "cls-18",
    d: "M311.01,68.7h17.28l8.14-8.14H319.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40566",
    "data-name": "Path 40566",
    className: "cls-17",
    d: "M409.72,60.56H392.45l-8.14,8.14h17.28Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40567",
    "data-name": "Path 40567",
    className: "cls-18",
    d: "M409.72,60.56H392.45l-8.14,8.14h17.28Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40568",
    "data-name": "Path 40568",
    className: "cls-17",
    d: "M373.08,60.56H355.8l-8.14,8.14h17.28Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40569",
    "data-name": "Path 40569",
    className: "cls-18",
    d: "M373.08,60.56H355.8l-8.14,8.14h17.28Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40570",
    "data-name": "Path 40570",
    className: "cls-17",
    d: "M446.37,60.56H429.1l-8.14,8.14h17.27Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40571",
    "data-name": "Path 40571",
    className: "cls-18",
    d: "M446.37,60.56H429.1l-8.14,8.14h17.27Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40572",
    "data-name": "Path 40572",
    className: "cls-17",
    d: "M483.02,60.56H465.74l-8.13,8.14h17.27Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40573",
    "data-name": "Path 40573",
    className: "cls-18",
    d: "M483.02,60.56H465.74l-8.13,8.14h17.27Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40574",
    "data-name": "Path 40574",
    className: "cls-17",
    d: "M592.96,60.56H575.69l-8.14,8.14h17.27Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40575",
    "data-name": "Path 40575",
    className: "cls-18",
    d: "M592.96,60.56H575.69l-8.14,8.14h17.27Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40576",
    "data-name": "Path 40576",
    className: "cls-17",
    d: "M556.32,60.56H539.04L530.9,68.7h17.28Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40577",
    "data-name": "Path 40577",
    className: "cls-18",
    d: "M556.32,60.56H539.04L530.9,68.7h17.28Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40578",
    "data-name": "Path 40578",
    className: "cls-17",
    d: "M519.67,60.56H502.39l-8.14,8.14h17.28Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40579",
    "data-name": "Path 40579",
    className: "cls-18",
    d: "M519.67,60.56H502.39l-8.14,8.14h17.28Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40580",
    "data-name": "Path 40580",
    className: "cls-17",
    d: "M629.61,60.56H612.34L604.2,68.7h17.27Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40581",
    "data-name": "Path 40581",
    className: "cls-18",
    d: "M629.61,60.56H612.34L604.2,68.7h17.27Z"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7628",
    "data-name": "Rectangle 7628",
    className: "cls-17",
    width: 56.93,
    height: 62.77,
    transform: "translate(108.04 38.55)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7629",
    "data-name": "Rectangle 7629",
    className: "cls-18",
    width: 56.93,
    height: 62.77,
    transform: "translate(108.04 38.55)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7630",
    "data-name": "Rectangle 7630",
    className: "cls-6",
    width: 18.55,
    height: 3.09,
    transform: "translate(466.88 37.69)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7631",
    "data-name": "Rectangle 7631",
    className: "cls-18",
    width: 18.55,
    height: 3.09,
    transform: "translate(466.88 37.69)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7632",
    "data-name": "Rectangle 7632",
    className: "cls-17",
    width: 60,
    height: 5.29,
    transform: "translate(227.58 68.42)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7633",
    "data-name": "Rectangle 7633",
    className: "cls-18",
    width: 60,
    height: 5.29,
    transform: "translate(227.58 68.42)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40582",
    "data-name": "Path 40582",
    className: "cls-6",
    d: "M564.59,212.3l-11.68-3.68L530.02,200l-2.11,6.3,25.46,17.1s8.92,3.59,9.56,4,3.31-14.1,3.31-14.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40583",
    "data-name": "Path 40583",
    className: "cls-18",
    d: "M564.59,212.3l-11.68-3.68L530.02,200l-2.11,6.3,25.46,17.1s8.92,3.59,9.56,4,3.31-14.1,3.31-14.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40584",
    "data-name": "Path 40584",
    className: "cls-3",
    d: "M531.12,199.36l-2.11,9.47-4.14-2.53s-7.35-.27-8.18-.46a4.388,4.388,0,0,1-1.28-.46s-1.11-9.19-.37-9.46a34.417,34.417,0,0,1,5.42-.46c.83,0,8.18,3.4,8.18,3.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40585",
    "data-name": "Path 40585",
    className: "cls-18",
    d: "M531.12,199.36l-2.11,9.47-4.14-2.53s-7.35-.27-8.18-.46a4.388,4.388,0,0,1-1.28-.46s-1.11-9.19-.37-9.46a34.417,34.417,0,0,1,5.42-.46c.83,0,8.18,3.4,8.18,3.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40586",
    "data-name": "Path 40586",
    className: "cls-3",
    d: "M527.81,198.9s-4.5-4.6-5.23-4.87a7,7,0,0,0-3.13.09c-.55.18-.83.64-.55,1.38s.09,5.05.46,5.42a1.57,1.57,0,0,0,1.65.28,2.37,2.37,0,0,0,.74-1,3.837,3.837,0,0,0,1.19,1.47,3,3,0,0,0,2.67-.18"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40587",
    "data-name": "Path 40587",
    className: "cls-18",
    d: "M527.81,198.9s-4.5-4.6-5.23-4.87a7,7,0,0,0-3.13.09c-.55.18-.83.64-.55,1.38s.09,5.05.46,5.42a1.57,1.57,0,0,0,1.65.28,2.37,2.37,0,0,0,.74-1,3.837,3.837,0,0,0,1.19,1.47,3,3,0,0,0,2.67-.18"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_67",
    "data-name": "Line 67",
    className: "cls-18",
    x1: 0.19,
    y1: 3.31,
    transform: "translate(521.56 196.87)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40588",
    "data-name": "Path 40588",
    className: "cls-3",
    d: "M516.69,197.79h-1.74a1.37,1.37,0,0,1-1.38-1.36v-.01a1.37,1.37,0,0,1,1.36-1.38h1.76a1.375,1.375,0,0,1,.01,2.75h-.01"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40589",
    "data-name": "Path 40589",
    className: "cls-18",
    d: "M516.69,197.79h-1.74a1.37,1.37,0,0,1-1.38-1.36v-.01a1.37,1.37,0,0,1,1.36-1.38h1.76a1.375,1.375,0,0,1,.01,2.75Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40590",
    "data-name": "Path 40590",
    className: "cls-3",
    d: "M517.06,200.86h-1.75a1.38,1.38,0,1,1,0-2.76h1.75a1.38,1.38,0,1,1,0,2.76"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40591",
    "data-name": "Path 40591",
    className: "cls-18",
    d: "M517.06,200.86h-1.75a1.38,1.38,0,1,1,0-2.76h1.75a1.38,1.38,0,1,1,0,2.76Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40592",
    "data-name": "Path 40592",
    className: "cls-3",
    d: "M517.8,203.42h-1.92a1.175,1.175,0,0,1-.01-2.35h1.93a1.175,1.175,0,0,1,.01,2.35h-.01"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40593",
    "data-name": "Path 40593",
    className: "cls-18",
    d: "M517.8,203.42h-1.92a1.175,1.175,0,0,1-.01-2.35h1.93a1.175,1.175,0,0,1,.01,2.35Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40594",
    "data-name": "Path 40594",
    className: "cls-3",
    d: "M517.91,205.9H516a1.17,1.17,0,0,1-1.18-1.16v-.01a1.18,1.18,0,0,1,1.18-1.18h1.91a1.175,1.175,0,1,1,.01,2.35h-.01"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40595",
    "data-name": "Path 40595",
    className: "cls-18",
    d: "M517.91,205.9H516a1.17,1.17,0,0,1-1.18-1.16v-.01a1.18,1.18,0,0,1,1.18-1.18h1.91a1.175,1.175,0,1,1,.01,2.35Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40596",
    "data-name": "Path 40596",
    className: "cls-6",
    d: "M557.52,321.68s-8,5.71-8.56,5.84-4.15.77-4.54,1.55a3.451,3.451,0,0,0-.39,2.72c.39.78,25.55,0,25.55,0a6.176,6.176,0,0,0,.26-3,44.352,44.352,0,0,1-.26-4.93Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40597",
    "data-name": "Path 40597",
    className: "cls-18",
    d: "M557.52,321.68s-8,5.71-8.56,5.84-4.15.77-4.54,1.55a3.451,3.451,0,0,0-.39,2.72c.39.78,25.55,0,25.55,0a6.176,6.176,0,0,0,.26-3,44.352,44.352,0,0,1-.26-4.93Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40598",
    "data-name": "Path 40598",
    className: "cls-6",
    d: "M569.86,330.37H543.93a2.189,2.189,0,0,0,.08,1.42c.39.78,25.55,0,25.55,0a5.707,5.707,0,0,0,.3-1.42"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40599",
    "data-name": "Path 40599",
    className: "cls-18",
    d: "M569.86,330.37H543.93a2.189,2.189,0,0,0,.08,1.42c.39.78,25.55,0,25.55,0A5.707,5.707,0,0,0,569.86,330.37Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40600",
    "data-name": "Path 40600",
    className: "cls-6",
    d: "M620.52,320.64l-1.56,4.41-5.83,5.06s-.39,1.43.26,1.68,11.8,0,11.8,0a13.13,13.13,0,0,0,2.46-1.55c.65-.65,6.23-8.69,6.1-9.6s-3.5-3.76-3.5-3.76Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40601",
    "data-name": "Path 40601",
    className: "cls-18",
    d: "M620.52,320.64l-1.56,4.41-5.83,5.06s-.39,1.43.26,1.68,11.8,0,11.8,0a13.13,13.13,0,0,0,2.46-1.55c.65-.65,6.23-8.69,6.1-9.6s-3.5-3.76-3.5-3.76Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40602",
    "data-name": "Path 40602",
    className: "cls-6",
    d: "M627.66,330.24c.65-.65,6.23-8.69,6.1-9.6a4.168,4.168,0,0,0-1.07-1.48c-2,3.34-5.86,9.69-6.71,10.17s-9.57.79-12.87.88c-.07.32-.26,1.37.29,1.58s11.8,0,11.8,0a13.128,13.128,0,0,0,2.46-1.55"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40603",
    "data-name": "Path 40603",
    className: "cls-18",
    d: "M627.66,330.24c.65-.65,6.23-8.69,6.1-9.6a4.168,4.168,0,0,0-1.07-1.48c-2,3.34-5.86,9.69-6.71,10.17s-9.57.79-12.87.88c-.07.32-.26,1.37.29,1.58s11.8,0,11.8,0A13.128,13.128,0,0,0,627.66,330.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40604",
    "data-name": "Path 40604",
    className: "cls-20",
    d: "M578.9,256.58a36.453,36.453,0,0,0-1,3.76c0,.52.13,2.2.13,2.2s-16.86,20-17.89,21.92-1.69,35.4-1.69,35.4-1.56.39-1.56.91a9.255,9.255,0,0,1-.26,1.56,36.663,36.663,0,0,0,5.19,2.59c2,.65,7.13,1.56,7.13,1.56a6.719,6.719,0,0,0,.65-2.6c0-1.29-.39-3.63-.39-4s5.31-29.07,5.31-29.07l16.47-18.15s7,20.23,8.43,21.4,19.19,24.64,19.19,24.64-1.29.77-.64,1.16a12.267,12.267,0,0,1,1.94,2.6s5.19-.78,7.26-2.08a9.235,9.235,0,0,0,3.12-3.5s-1.56-2.72-2.21-3.5-1.56-2.08-1.56-2.08l-14.91-26.19s-3.5-29.31-4.54-32-4.67-7-4.67-7Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40605",
    "data-name": "Path 40605",
    className: "cls-18",
    d: "M578.9,256.58a36.453,36.453,0,0,0-1,3.76c0,.52.13,2.2.13,2.2s-16.86,20-17.89,21.92-1.69,35.4-1.69,35.4-1.56.39-1.56.91a9.255,9.255,0,0,1-.26,1.56,36.663,36.663,0,0,0,5.19,2.59c2,.65,7.13,1.56,7.13,1.56a6.719,6.719,0,0,0,.65-2.6c0-1.29-.39-3.63-.39-4s5.31-29.07,5.31-29.07l16.47-18.15s7,20.23,8.43,21.4,19.19,24.64,19.19,24.64-1.29.77-.64,1.16a12.267,12.267,0,0,1,1.94,2.6s5.19-.78,7.26-2.08a9.235,9.235,0,0,0,3.12-3.5s-1.56-2.72-2.21-3.5-1.56-2.08-1.56-2.08l-14.91-26.19s-3.5-29.31-4.54-32-4.67-7-4.67-7Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40606",
    "data-name": "Path 40606",
    className: "cls-17",
    d: "M578.12,259.17l25.94-11.28-1.69-1.82-23.6,9.47Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40607",
    "data-name": "Path 40607",
    className: "cls-18",
    d: "M578.12,259.17l25.94-11.28-1.69-1.82-23.6,9.47Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40608",
    "data-name": "Path 40608",
    className: "cls-18",
    d: "M583.83,257.87l.65,2.08s-1.3.78-1,1.43a12.274,12.274,0,0,0,1.94,2.2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40609",
    "data-name": "Path 40609",
    className: "cls-18",
    d: "M585.9,256.97l1,2.33s-1.3,1-.65,1.95a17.569,17.569,0,0,0,1.56,1.81"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40610",
    "data-name": "Path 40610",
    className: "cls-17",
    d: "M594.438,249.529l2.154-1.035a3.15,3.15,0,0,1,4.2,1.474l2.551,5.309a3.15,3.15,0,0,1-1.474,4.2l-2.154,1.035a3.151,3.151,0,0,1-4.2-1.475l-2.552-5.308a3.151,3.151,0,0,1,1.475-4.2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_7634",
    "data-name": "Rectangle 7634",
    className: "cls-18",
    d: "M3.15,0H5.541A3.149,3.149,0,0,1,8.69,3.149V9.041A3.149,3.149,0,0,1,5.541,12.19H3.15A3.15,3.15,0,0,1,0,9.04V3.15A3.15,3.15,0,0,1,3.15,0Z",
    transform: "translate(591.599 250.893) rotate(-25.665)"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_68",
    "data-name": "Line 68",
    className: "cls-18",
    x1: 0.9,
    y1: 1.13,
    transform: "translate(585.51 265.79)"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_69",
    "data-name": "Line 69",
    className: "cls-18",
    x1: 2.84,
    y1: 3.59,
    transform: "translate(588.12 269.07)"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_70",
    "data-name": "Line 70",
    className: "cls-18",
    x2: 2.15,
    y2: 3.77,
    transform: "translate(619.81 304.81)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40611",
    "data-name": "Path 40611",
    className: "cls-18",
    d: "M603.8,262.15l4.93,22.44-.39,1.82s1.55.25,1.55.64v.39l8.48,14.86"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_71",
    "data-name": "Line 71",
    className: "cls-18",
    x1: 0.84,
    y2: 6.2,
    transform: "translate(565.67 312.76)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40612",
    "data-name": "Path 40612",
    className: "cls-18",
    d: "M586.52,271.75,570.34,290.3s-2.59-.26-2.2.38a15.333,15.333,0,0,0,1.16,1.56l-2.5,18.42"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40613",
    "data-name": "Path 40613",
    className: "cls-3",
    d: "M561.37,224.36s1.28,12.78,2.39,14.16,11.67,11.58,11.67,11.58,2.12,6.34,2.21,6.8-.56,1.25,1,1,23.17-10.07,23.91-10.8a4.377,4.377,0,0,0,1.1-2.67,4.213,4.213,0,0,0-1-2,17.689,17.689,0,0,0-2.11-1.66s-10-17-12.23-19.12-10.29-9.19-14-9.93a44.5,44.5,0,0,0-8.55-.55Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40614",
    "data-name": "Path 40614",
    className: "cls-18",
    d: "M561.37,224.36s1.28,12.78,2.39,14.16,11.67,11.58,11.67,11.58,2.12,6.34,2.21,6.8-.56,1.25,1,1,23.17-10.07,23.91-10.8a4.377,4.377,0,0,0,1.1-2.67,4.213,4.213,0,0,0-1-2,17.689,17.689,0,0,0-2.11-1.66s-10-17-12.23-19.12-10.29-9.19-14-9.93a44.5,44.5,0,0,0-8.55-.55Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40615",
    "data-name": "Path 40615",
    className: "cls-6",
    d: "M543.63,221.05s3.31,3.86,3.67,3.68a13.824,13.824,0,0,0,1.66-2.12s5.33,2.95,5.88,2.49a30.077,30.077,0,0,0,2.39-3.77l2.94,1.93,4-11.77-4.69-1-2.67-4Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40616",
    "data-name": "Path 40616",
    className: "cls-18",
    d: "M543.63,221.05s3.31,3.86,3.67,3.68a13.824,13.824,0,0,0,1.66-2.12s5.33,2.95,5.88,2.49a30.077,30.077,0,0,0,2.39-3.77l2.94,1.93,4-11.77-4.69-1-2.67-4Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40617",
    "data-name": "Path 40617",
    className: "cls-17",
    d: "M548.24,215.92c.53.1,2.9.49,3.48.17s1.28-.83,1.19-1.66c0,0-.64-2.57.55-3.31s2.12-.18,2.58,1.11a4.926,4.926,0,0,1,0,2.75s2.39-1.37,2.66-2.66a4.542,4.542,0,0,1,.74-1.84l-2.67-4Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40618",
    "data-name": "Path 40618",
    className: "cls-18",
    d: "M548.24,215.92c.53.1,2.9.49,3.48.17s1.28-.83,1.19-1.66c0,0-.64-2.57.55-3.31s2.12-.18,2.58,1.11a4.926,4.926,0,0,1,0,2.75s2.39-1.37,2.66-2.66a4.542,4.542,0,0,1,.74-1.84l-2.67-4Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40619",
    "data-name": "Path 40619",
    className: "cls-6",
    d: "M539.12,206.44a11.114,11.114,0,0,0-2.11,5.42c-.09,2.76,4.13,7.63,4.23,7.9s.18,5.06.18,5.06l17.93-19a13.219,13.219,0,0,1-4-1.1c-1.1-.74-3.77-3.4-7-3.31s-7.57,2.73-9.23,5.03"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40620",
    "data-name": "Path 40620",
    className: "cls-18",
    d: "M539.12,206.44a11.114,11.114,0,0,0-2.11,5.42c-.09,2.76,4.13,7.63,4.23,7.9s.18,5.06.18,5.06l17.93-19a13.219,13.219,0,0,1-4-1.1c-1.1-.74-3.77-3.4-7-3.31S540.78,204.14,539.12,206.44Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40621",
    "data-name": "Path 40621",
    className: "cls-6",
    d: "M563.39,210.57l-4.32,13.97,3.86,2.85,3.95-16.73Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40622",
    "data-name": "Path 40622",
    className: "cls-18",
    d: "M563.39,210.57l-4.32,13.97,3.86,2.85,3.95-16.73Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40623",
    "data-name": "Path 40623",
    className: "cls-6",
    d: "M563.39,237.67l24.13-16.8c-1.1-1-2.77-2.46-4.59-3.92l-20.72,14.43a49.208,49.208,0,0,0,1.18,6.29"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40624",
    "data-name": "Path 40624",
    className: "cls-18",
    d: "M563.39,237.67l24.13-16.8c-1.1-1-2.77-2.46-4.59-3.92l-20.72,14.43A49.208,49.208,0,0,0,563.39,237.67Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40625",
    "data-name": "Path 40625",
    className: "cls-6",
    d: "M596.2,233.53l-24.36,13.08c2,2,3.59,3.49,3.59,3.49l.34,1,23.45-12.59c-.78-1.29-1.84-3.07-3.02-4.98"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40626",
    "data-name": "Path 40626",
    className: "cls-18",
    d: "M596.2,233.53l-24.36,13.08c2,2,3.59,3.49,3.59,3.49l.34,1,23.45-12.59C598.44,237.22,597.38,235.44,596.2,233.53Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40627",
    "data-name": "Path 40627",
    className: "cls-6",
    d: "M568.52,234.1s6.16,3.41,10.11,2,4-9,2.48-13.15-8.09-7.63-12.22-7.26-10,9.56-10.39,9.74-8.18,7.54-8.18,7.54l-20.41-4.14-2.21,7.18s24.55,8,25.56,8.18a9.137,9.137,0,0,0,3.68-.56c.66-.24,11.58-9.53,11.58-9.53"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40628",
    "data-name": "Path 40628",
    className: "cls-18",
    d: "M568.52,234.1s6.16,3.41,10.11,2,4-9,2.48-13.15-8.09-7.63-12.22-7.26-10,9.56-10.39,9.74-8.18,7.54-8.18,7.54l-20.41-4.14-2.21,7.18s24.55,8,25.56,8.18a9.137,9.137,0,0,0,3.68-.56C557.6,243.39,568.52,234.1,568.52,234.1Z"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_72",
    "data-name": "Line 72",
    className: "cls-18",
    y1: 5.15,
    x2: 7.17,
    transform: "translate(568.54 228.56)"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_73",
    "data-name": "Line 73",
    className: "cls-18",
    y1: 2.39,
    x2: 6.16,
    transform: "translate(570.19 230.7)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40629",
    "data-name": "Path 40629",
    className: "cls-3",
    d: "M534.02,228.79l-7.12-3.05-3.87-3.31a17.041,17.041,0,0,1-2.75-1.47c-.65-.55-.83-1.84-1.66-1.2s-1.28,1.48-1,2.12a7.479,7.479,0,0,0,1.38,1.65l.55.83-3.12.09s-1,1-.56,2a5.632,5.632,0,0,0,1.57,1.84s-.19,3.77.64,4.78,7.26,2.3,7.26,2.3l5.61,2.48Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40630",
    "data-name": "Path 40630",
    className: "cls-18",
    d: "M534.02,228.79l-7.12-3.05-3.87-3.31a17.041,17.041,0,0,1-2.75-1.47c-.65-.55-.83-1.84-1.66-1.2s-1.28,1.48-1,2.12a7.479,7.479,0,0,0,1.38,1.65l.55.83-3.12.09s-1,1-.56,2a5.632,5.632,0,0,0,1.57,1.84s-.19,3.77.64,4.78,7.26,2.3,7.26,2.3l5.61,2.48Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40631",
    "data-name": "Path 40631",
    className: "cls-20",
    d: "M159.86,249.75l-15.71.69-15.71-.69,1.79,32.39,2.76,36.52s-1.38,1-1.11,1.93,1,4.55,1,4.55h22.6s.69-3.58,1-4.55-1.11-1.93-1.11-1.93l2.76-36.52Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40632",
    "data-name": "Path 40632",
    className: "cls-18",
    d: "M159.86,249.75l-15.71.69-15.71-.69,1.79,32.39,2.76,36.52s-1.38,1-1.11,1.93,1,4.55,1,4.55h22.6s.69-3.58,1-4.55-1.11-1.93-1.11-1.93l2.76-36.52Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40633",
    "data-name": "Path 40633",
    className: "cls-6",
    d: "M159.52,205.85l11.76,10.5s10.62-10.28,11.76-10.05,4.34,3.54,4.23,4.11-12.33,18.73-13.36,19.3a5.792,5.792,0,0,1-5.14.69c-2.62-.8-9.25-7.1-9.25-7.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40634",
    "data-name": "Path 40634",
    className: "cls-18",
    d: "M159.52,205.85l11.76,10.5s10.62-10.28,11.76-10.05,4.34,3.54,4.23,4.11-12.33,18.73-13.36,19.3a5.792,5.792,0,0,1-5.14.69c-2.62-.8-9.25-7.1-9.25-7.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40635",
    "data-name": "Path 40635",
    className: "cls-3",
    d: "M134.93,201.61l-10,5.09,1.28,35.49s-1.66.93-1.24,1.66a16.592,16.592,0,0,0,1.24,1.76s3.07,1,3.38,2.6l.29,1.14h28.64s2.28-2.08,2.59-3a7.571,7.571,0,0,0-.41-3.53c-.21-.62-1.25-3.11-1.25-3.11s1.21-34,.9-34.43-10.9-3.55-10.9-3.55l-7.06-1.87Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40636",
    "data-name": "Path 40636",
    className: "cls-18",
    d: "M134.93,201.61l-10,5.09,1.28,35.49s-1.66.93-1.24,1.66a16.592,16.592,0,0,0,1.24,1.76s3.07,1,3.38,2.6l.29,1.14h28.64s2.28-2.08,2.59-3a7.571,7.571,0,0,0-.41-3.53c-.21-.62-1.25-3.11-1.25-3.11s1.21-34,.9-34.43-10.9-3.55-10.9-3.55l-7.06-1.87Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40637",
    "data-name": "Path 40637",
    className: "cls-6",
    d: "M159.46,235.33h-33.3l-.34-7.81h33.91Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40638",
    "data-name": "Path 40638",
    className: "cls-18",
    d: "M159.46,235.33h-33.3l-.34-7.81h33.91Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40639",
    "data-name": "Path 40639",
    className: "cls-6",
    d: "M160.2,212.76H125.25l-.27-4.28H160.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40640",
    "data-name": "Path 40640",
    className: "cls-18",
    d: "M160.2,212.76H125.25l-.27-4.28H160.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40641",
    "data-name": "Path 40641",
    className: "cls-6",
    d: "M149.46,201.72l-7.06-1.87-7.47,1.76-.88.45a24.251,24.251,0,0,0,3.27,7.54c2.7,3.84,4.67,6.69,6.12,6.69s6-6.17,6.85-8.87a47.043,47.043,0,0,0,1.19-5.34Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40642",
    "data-name": "Path 40642",
    className: "cls-18",
    d: "M149.46,201.72l-7.06-1.87-7.47,1.76-.88.45a24.251,24.251,0,0,0,3.27,7.54c2.7,3.84,4.67,6.69,6.12,6.69s6-6.17,6.85-8.87a47.043,47.043,0,0,0,1.19-5.34Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40643",
    "data-name": "Path 40643",
    className: "cls-6",
    d: "M153.41,184.7s.41,2.59,1.14,3.42,2.28.1,2.8,1.66-2.28,2.91-2.28,2.91-.11,4.15-.32,5.19-.62,1.35-2.18,1.76a16.776,16.776,0,0,1-4,.31l-5.4,7.37-6.54-8.3.21-3.43-2.7-4.36Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40644",
    "data-name": "Path 40644",
    className: "cls-18",
    d: "M153.41,184.7s.41,2.59,1.14,3.42,2.28.1,2.8,1.66-2.28,2.91-2.28,2.91-.11,4.15-.32,5.19-.62,1.35-2.18,1.76a16.776,16.776,0,0,1-4,.31l-5.4,7.37-6.54-8.3.21-3.43-2.7-4.36Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40645",
    "data-name": "Path 40645",
    className: "cls-17",
    d: "M136.39,194.87s2.8,2,3.73,1.55,1-2.59,1.14-3,.42-3,.42-3,1.14-.1,1.87,2.18a18.279,18.279,0,0,0,3.21,6c1.25,1.46,1.77,1.35,1.77,1.35s4.36.42,5.71-.62,1.45-1.25,1.34-2.49.42-3.84-.51-4.15-3.53,1.14-4.67,1.76-.73,1.25-2,.62a8.007,8.007,0,0,1-3.21-2.49c-.52-.93-.31-4.56-.31-4.56l-10.8,3.21a5.854,5.854,0,0,0,2.31,3.64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40646",
    "data-name": "Path 40646",
    className: "cls-18",
    d: "M136.39,194.87s2.8,2,3.73,1.55,1-2.59,1.14-3,.42-3,.42-3,1.14-.1,1.87,2.18a18.279,18.279,0,0,0,3.21,6c1.25,1.46,1.77,1.35,1.77,1.35s4.36.42,5.71-.62,1.45-1.25,1.34-2.49.42-3.84-.51-4.15-3.53,1.14-4.67,1.76-.73,1.25-2,.62a8.007,8.007,0,0,1-3.21-2.49c-.52-.93-.31-4.56-.31-4.56l-10.8,3.21A5.854,5.854,0,0,0,136.39,194.87Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40647",
    "data-name": "Path 40647",
    className: "cls-6",
    d: "M139.08,189.37l-4.46,5.7,2.28,2.08,5.4-8.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40648",
    "data-name": "Path 40648",
    className: "cls-18",
    d: "M139.08,189.37l-4.46,5.7,2.28,2.08,5.4-8.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40649",
    "data-name": "Path 40649",
    className: "cls-6",
    d: "M133.45,192.35l24.46-8.27a17.609,17.609,0,0,1-5.34-2.8c-1-1-1.36-2.41-2.06-3.59-2.07-3.47-7.71-3.75-11.13-2.63-4.4,1.44-8.44,5.9-7.46,10.8a33.19,33.19,0,0,0,1.14,3.82,9.848,9.848,0,0,1,.39,2.67"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40650",
    "data-name": "Path 40650",
    className: "cls-18",
    d: "M133.45,192.35l24.46-8.27a17.609,17.609,0,0,1-5.34-2.8c-1-1-1.36-2.41-2.06-3.59-2.07-3.47-7.71-3.75-11.13-2.63-4.4,1.44-8.44,5.9-7.46,10.8a33.19,33.19,0,0,0,1.14,3.82A9.848,9.848,0,0,1,133.45,192.35Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40651",
    "data-name": "Path 40651",
    className: "cls-6",
    d: "M143.03,191.75s-1.35-2.59-3.12-1.35-.1,3.84.83,4.78,2.6-.31,2.81-.62"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40652",
    "data-name": "Path 40652",
    className: "cls-18",
    d: "M143.03,191.75s-1.35-2.59-3.12-1.35-.1,3.84.83,4.78,2.6-.31,2.81-.62"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40653",
    "data-name": "Path 40653",
    className: "cls-6",
    d: "M143.13,207.32l-4.05,3.32-4.87-9.24,2.38-2.38Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40654",
    "data-name": "Path 40654",
    className: "cls-18",
    d: "M143.13,207.32l-4.05,3.32-4.87-9.24,2.38-2.38Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40655",
    "data-name": "Path 40655",
    className: "cls-6",
    d: "M143.13,207.32l4.36,3.42,3.43-8.82-2.39-1.97Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40656",
    "data-name": "Path 40656",
    className: "cls-18",
    d: "M143.13,207.32l4.36,3.42,3.43-8.82-2.39-1.97Z"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_74",
    "data-name": "Line 74",
    className: "cls-18",
    y2: 30.48,
    transform: "translate(143.35 217.33)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7635",
    "data-name": "Rectangle 7635",
    className: "cls-17",
    width: 30.47,
    height: 3.43,
    transform: "translate(129.63 248.19)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7636",
    "data-name": "Rectangle 7636",
    className: "cls-18",
    width: 30.47,
    height: 3.43,
    transform: "translate(129.63 248.19)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7637",
    "data-name": "Rectangle 7637",
    className: "cls-17",
    width: 5.62,
    height: 12.19,
    transform: "translate(124.59 246.19)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7638",
    "data-name": "Rectangle 7638",
    className: "cls-18",
    width: 5.62,
    height: 12.19,
    transform: "translate(124.59 246.19)"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_75",
    "data-name": "Line 75",
    className: "cls-18",
    y1: 34.06,
    x2: 0.22,
    transform: "translate(144.34 262.98)"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_76",
    "data-name": "Line 76",
    className: "cls-18",
    y1: 24.22,
    x2: 0.16,
    transform: "translate(144.15 300.92)"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_77",
    "data-name": "Line 77",
    className: "cls-18",
    x2: 4.96,
    transform: "translate(141.81 262.98)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40657",
    "data-name": "Path 40657",
    className: "cls-6",
    d: "M143.96,326.66s.69-3.65,3.08-4.8,5.49.69,6.63,1.72,1.79,1.56,1.79,1.56a17.1,17.1,0,0,0,2,2.55c.68.57,2.05.8,2.39,1.71a12.354,12.354,0,0,1,.46,2.74H143.73Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40658",
    "data-name": "Path 40658",
    className: "cls-18",
    d: "M143.96,326.66s.69-3.65,3.08-4.8,5.49.69,6.63,1.72,1.79,1.56,1.79,1.56a17.1,17.1,0,0,0,2,2.55c.68.57,2.05.8,2.39,1.71a12.354,12.354,0,0,1,.46,2.74H143.73Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40659",
    "data-name": "Path 40659",
    className: "cls-6",
    d: "M160.29,332.14H143.73l.08-1.83h16.26q.156.909.22,1.83"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40660",
    "data-name": "Path 40660",
    className: "cls-18",
    d: "M160.29,332.14H143.73l.08-1.83h16.26Q160.226,331.219,160.29,332.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40661",
    "data-name": "Path 40661",
    className: "cls-6",
    d: "M144.34,326.66s-.68-3.65-3.08-4.8-5.48.69-6.62,1.72-1.79,1.56-1.79,1.56a17.785,17.785,0,0,1-2,2.55c-.69.57-2.06.8-2.4,1.71a13.048,13.048,0,0,0-.46,2.74h16.56Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40662",
    "data-name": "Path 40662",
    className: "cls-18",
    d: "M144.34,326.66s-.68-3.65-3.08-4.8-5.48.69-6.62,1.72-1.79,1.56-1.79,1.56a17.785,17.785,0,0,1-2,2.55c-.69.57-2.06.8-2.4,1.71a13.048,13.048,0,0,0-.46,2.74h16.56Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40663",
    "data-name": "Path 40663",
    className: "cls-6",
    d: "M128.01,332.14h16.56l-.05-1.84H128.24a16.752,16.752,0,0,0-.23,1.84"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40664",
    "data-name": "Path 40664",
    className: "cls-18",
    d: "M128.01,332.14h16.56l-.05-1.84H128.24A16.752,16.752,0,0,0,128.01,332.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40665",
    "data-name": "Path 40665",
    className: "cls-6",
    d: "M124.97,206.7a73.936,73.936,0,0,0-5.06,13.3c-2.06,7.54-3.43,13.94-3.77,18.85s-.92,13.13-.69,13.59,5.71.11,6.17-.12,3.65-13,3.65-13l1.94-7-.57-24.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40666",
    "data-name": "Path 40666",
    className: "cls-18",
    d: "M124.97,206.7a73.936,73.936,0,0,0-5.06,13.3c-2.06,7.54-3.43,13.94-3.77,18.85s-.92,13.13-.69,13.59,5.71.11,6.17-.12,3.65-13,3.65-13l1.94-7-.57-24.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40667",
    "data-name": "Path 40667",
    className: "cls-3",
    d: "M114.27,250.59a18.167,18.167,0,0,1,.9,2.72,64.96,64.96,0,0,1,.74,7,33.258,33.258,0,0,0,1.94,5.71c.46.69,2.17,1.6,3.08,1.26s1.6-.8,1.37-1.37a8.057,8.057,0,0,0-.68-1.26s1.25-.68,1.37-1.59a26.058,26.058,0,0,0,.23-6.17c-.17-.92-.81-3-1-4.14a4.74,4.74,0,0,1,.62-2.58Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40668",
    "data-name": "Path 40668",
    className: "cls-18",
    d: "M114.27,250.59a18.167,18.167,0,0,1,.9,2.72,64.96,64.96,0,0,1,.74,7,33.258,33.258,0,0,0,1.94,5.71c.46.69,2.17,1.6,3.08,1.26s1.6-.8,1.37-1.37a8.057,8.057,0,0,0-.68-1.26s1.25-.68,1.37-1.59a26.058,26.058,0,0,0,.23-6.17c-.17-.92-.81-3-1-4.14a4.74,4.74,0,0,1,.62-2.58Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40669",
    "data-name": "Path 40669",
    className: "cls-18",
    d: "M121.62,264.65s-.69-2.51-.69-2.85l.59-2.5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40670",
    "data-name": "Path 40670",
    className: "cls-3",
    d: "M197.86,197.75c-.28,0-4.05,2.44-4.05,2.44l-.9-.07a63.257,63.257,0,0,0,3.9-5.16c.14-.56-.49-.7-.77-.7s-4.6,3.35-4.6,3.35l-.83-.14s2.09-3.21,2.37-3.77.14-.77-.28-.9a1.379,1.379,0,0,0-1.54.76c-.34.7-7.66,7.53-7.8,7.88a33.92,33.92,0,0,0-.25,3.46l-2.47,2.74,6.27,5.58,2.58-5.09a4.573,4.573,0,0,1,1.2-.62,17.066,17.066,0,0,0,2.51-2.17,49.761,49.761,0,0,0,4.81-2.37c.41-.41.07-1.18.07-1.18l-4,1a49.073,49.073,0,0,0,4.39-3.9.84.84,0,0,0-.461-1.1.853.853,0,0,0-.149-.045"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40671",
    "data-name": "Path 40671",
    className: "cls-18",
    d: "M197.86,197.75c-.28,0-4.05,2.44-4.05,2.44l-.9-.07a63.257,63.257,0,0,0,3.9-5.16c.14-.56-.49-.7-.77-.7s-4.6,3.35-4.6,3.35l-.83-.14s2.09-3.21,2.37-3.77.14-.77-.28-.9a1.379,1.379,0,0,0-1.54.76c-.34.7-7.66,7.53-7.8,7.88a33.92,33.92,0,0,0-.25,3.46l-2.47,2.74,6.27,5.58,2.58-5.09a4.573,4.573,0,0,1,1.2-.62,17.066,17.066,0,0,0,2.51-2.17,49.761,49.761,0,0,0,4.81-2.37c.41-.41.07-1.18.07-1.18l-4,1a49.073,49.073,0,0,0,4.39-3.9.84.84,0,0,0-.461-1.1A.853.853,0,0,0,197.86,197.75Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40672",
    "data-name": "Path 40672",
    className: "cls-3",
    d: "M183.36,202.69s-.07-3.48,0-3.69,2.09-2.65,2.37-3.21.9-2.09,1.46-2a1.67,1.67,0,0,1,1.25,1.67,14.557,14.557,0,0,1-1.32,2.79,23.272,23.272,0,0,0-.07,3.35,4.084,4.084,0,0,1,.07,2.23"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40673",
    "data-name": "Path 40673",
    className: "cls-18",
    d: "M183.36,202.69s-.07-3.48,0-3.69,2.09-2.65,2.37-3.21.9-2.09,1.46-2a1.67,1.67,0,0,1,1.25,1.67,14.557,14.557,0,0,1-1.32,2.79,23.272,23.272,0,0,0-.07,3.35,4.084,4.084,0,0,1,.07,2.23"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40674",
    "data-name": "Path 40674",
    className: "cls-6",
    d: "M66.22,197.65s-5.87,9.21-6.78,12.85,2.43,22,2.43,22-1.32,8.4-.91,9.21a4.654,4.654,0,0,0,1.21,1.42H87.68a10.885,10.885,0,0,0,1.21-2.93,8.727,8.727,0,0,0-.2-3.85c-.51-1.72-1.72-21.45-2.94-25.1s-6.47-10.32-6.47-10.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40675",
    "data-name": "Path 40675",
    className: "cls-18",
    d: "M66.22,197.65s-5.87,9.21-6.78,12.85,2.43,22,2.43,22-1.32,8.4-.91,9.21a4.654,4.654,0,0,0,1.21,1.42H87.68a10.885,10.885,0,0,0,1.21-2.93,8.727,8.727,0,0,0-.2-3.85c-.51-1.72-1.72-21.45-2.94-25.1s-6.47-10.32-6.47-10.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40676",
    "data-name": "Path 40676",
    className: "cls-6",
    d: "M79.28,179.84s2.22,2.22,2.93,2.83,2.23.81,2,1.52a8.609,8.609,0,0,1-1.9,2.11s.91,4,1.21,5.08-.1,1.61-1.42,1.92a18.893,18.893,0,0,1-3.34.3l-.51,5.06-11.43-2.93-.41-3.24s-3.54-.41-4.25-2.84Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40677",
    "data-name": "Path 40677",
    className: "cls-18",
    d: "M79.28,179.84s2.22,2.22,2.93,2.83,2.23.81,2,1.52a8.609,8.609,0,0,1-1.9,2.11s.91,4,1.21,5.08-.1,1.61-1.42,1.92a18.893,18.893,0,0,1-3.34.3l-.51,5.06-11.43-2.93-.41-3.24s-3.54-.41-4.25-2.84Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40678",
    "data-name": "Path 40678",
    className: "cls-17",
    d: "M69.05,192.49a3.663,3.663,0,0,0,1.12-2.19,3.072,3.072,0,0,1-1.42-.61,5.575,5.575,0,0,1-1.11-1.92c-.1-.61,1-1.62,2.22-1.82s1,.81,1.73.81.91,0,1.31-.3.4-2.68.41-3.15l-11.14,6.38c.71,2.43,4.25,2.84,4.25,2.84s1.52,1.17,2.63-.04"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40679",
    "data-name": "Path 40679",
    className: "cls-18",
    d: "M69.05,192.49a3.663,3.663,0,0,0,1.12-2.19,3.072,3.072,0,0,1-1.42-.61,5.575,5.575,0,0,1-1.11-1.92c-.1-.61,1-1.62,2.22-1.82s1,.81,1.73.81.91,0,1.31-.3.4-2.68.41-3.15l-11.14,6.38c.71,2.43,4.25,2.84,4.25,2.84S67.94,193.7,69.05,192.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40680",
    "data-name": "Path 40680",
    className: "cls-6",
    d: "M66.83,187.53l-2.94,5.97,1.82,1.11,4.15-8.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40681",
    "data-name": "Path 40681",
    className: "cls-18",
    d: "M66.83,187.53l-2.94,5.97,1.82,1.11,4.15-8.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40682",
    "data-name": "Path 40682",
    className: "cls-6",
    d: "M60.63,191.7l23-13.18a21.905,21.905,0,0,1-4.44-.4c-1.21-.4-3.23-3.23-4.84-4.57s-6.32-.67-9.41.27-6.59,6-6.59,7.66,2.55,6.73,3,7.26-.72,2.96-.72,2.96"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40683",
    "data-name": "Path 40683",
    className: "cls-18",
    d: "M60.63,191.7l23-13.18a21.905,21.905,0,0,1-4.44-.4c-1.21-.4-3.23-3.23-4.84-4.57s-6.32-.67-9.41.27-6.59,6-6.59,7.66,2.55,6.73,3,7.26S60.63,191.7,60.63,191.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40684",
    "data-name": "Path 40684",
    className: "cls-6",
    d: "M66.42,194.51l14.07,4.66-.5,5.67-14.68-6.79Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40685",
    "data-name": "Path 40685",
    className: "cls-18",
    d: "M66.42,194.51l14.07,4.66-.5,5.67-14.68-6.79Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40686",
    "data-name": "Path 40686",
    className: "cls-17",
    d: "M78.77,193.6l-2.73-.2,2.23,3.34Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40687",
    "data-name": "Path 40687",
    className: "cls-18",
    d: "M78.77,193.6l-2.73-.2,2.23,3.34Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40688",
    "data-name": "Path 40688",
    className: "cls-21",
    d: "M116.72,205.34l-13.66-10.02-6.58,26.42,2.03,2.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40689",
    "data-name": "Path 40689",
    className: "cls-18",
    d: "M116.72,205.34l-13.66-10.02-6.58,26.42,2.03,2.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40690",
    "data-name": "Path 40690",
    className: "cls-6",
    d: "M110.75,191.58,97.8,222.3,85.35,236.61l7.59,6.28,11.33-17.41s14.48-18.22,14.88-19.43-8.4-14.47-8.4-14.47"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40691",
    "data-name": "Path 40691",
    className: "cls-18",
    d: "M110.75,191.58,97.8,222.3,85.35,236.61l7.59,6.28,11.33-17.41s14.48-18.22,14.88-19.43S110.75,191.58,110.75,191.58Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40692",
    "data-name": "Path 40692",
    className: "cls-22",
    d: "M69.16,267.55l-2.38,18s-2.91,22.24-3.57,27.4-.4,18.79-.4,18.79H73l.13-19.19-.26-32.82Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40693",
    "data-name": "Path 40693",
    className: "cls-18",
    d: "M69.16,267.55l-2.38,18s-2.91,22.24-3.57,27.4-.4,18.79-.4,18.79H73l.13-19.19-.26-32.82Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40694",
    "data-name": "Path 40694",
    className: "cls-6",
    d: "M62.76,326.21v5.53H73l.06-8.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40695",
    "data-name": "Path 40695",
    className: "cls-18",
    d: "M62.76,326.21v5.53H73l.06-8.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40696",
    "data-name": "Path 40696",
    className: "cls-6",
    d: "M62.78,329.63v2.1H73v-2.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40697",
    "data-name": "Path 40697",
    className: "cls-18",
    d: "M62.78,329.63v2.1H73v-2.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40698",
    "data-name": "Path 40698",
    className: "cls-6",
    d: "M84.25,321.95s3.84,3.84,5.69,4.63,4.77,1.06,5.16,2a11.258,11.258,0,0,1,.13,3.57H69.96a10.514,10.514,0,0,1-.44-3.85,9.024,9.024,0,0,1,.66-2.38s12.48-4.1,14.07-3.97"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40699",
    "data-name": "Path 40699",
    className: "cls-18",
    d: "M84.25,321.95s3.84,3.84,5.69,4.63,4.77,1.06,5.16,2a11.258,11.258,0,0,1,.13,3.57H69.96a10.514,10.514,0,0,1-.44-3.85,9.024,9.024,0,0,1,.66-2.38S82.66,321.82,84.25,321.95Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40700",
    "data-name": "Path 40700",
    className: "cls-6",
    d: "M69.96,332.14H95.23a20.28,20.28,0,0,0,.09-2.12H69.52a13.574,13.574,0,0,0,.44,2.12"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40701",
    "data-name": "Path 40701",
    className: "cls-18",
    d: "M69.96,332.14H95.23a20.28,20.28,0,0,0,.09-2.12H69.52A13.574,13.574,0,0,0,69.96,332.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40702",
    "data-name": "Path 40702",
    className: "cls-20",
    d: "M62.68,242.01s.13,8.07,1.32,10.32,3.57,6.09,3.57,6.09,3,25,2.52,27.4-2.25,8.6-2.12,13,2.38,22.76,2.38,22.76-.66,1.19-.53,1.59.4,2.78.4,2.78,4.1-.66,7-1.46a70.859,70.859,0,0,0,7-2.51,4.471,4.471,0,0,0,.13-2.51c-.4-.93-1.45-3.58-1.45-3.58s.39-15.62.39-18.26,2.12-14.16,2.12-16.55,2.52-24.48,2.12-27-.66-6.35-.66-6.35l.66-6Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40703",
    "data-name": "Path 40703",
    className: "cls-18",
    d: "M62.68,242.01s.13,8.07,1.32,10.32,3.57,6.09,3.57,6.09,3,25,2.52,27.4-2.25,8.6-2.12,13,2.38,22.76,2.38,22.76-.66,1.19-.53,1.59.4,2.78.4,2.78,4.1-.66,7-1.46a70.859,70.859,0,0,0,7-2.51,4.471,4.471,0,0,0,.13-2.51c-.4-.93-1.45-3.58-1.45-3.58s.39-15.62.39-18.26,2.12-14.16,2.12-16.55,2.52-24.48,2.12-27-.66-6.35-.66-6.35l.66-6Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40704",
    "data-name": "Path 40704",
    className: "cls-17",
    d: "M62.87,246.11h24.2l.49-4.37-24.88.27s.03,1.89.19,4.1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40705",
    "data-name": "Path 40705",
    className: "cls-18",
    d: "M62.87,246.11h24.2l.49-4.37-24.88.27S62.71,243.9,62.87,246.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40706",
    "data-name": "Path 40706",
    className: "cls-17",
    d: "M74.05,241.48h3.19a3.7,3.7,0,0,1,3.7,3.7v5.7a3.7,3.7,0,0,1-3.7,3.7H74.05a3.7,3.7,0,0,1-3.7-3.7v-5.7a3.7,3.7,0,0,1,3.7-3.7"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7639",
    "data-name": "Rectangle 7639",
    className: "cls-18",
    width: 10.59,
    height: 13.1,
    rx: 3.7,
    transform: "translate(70.35 241.48)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40707",
    "data-name": "Path 40707",
    className: "cls-18",
    d: "M76.52,261.76c-.1,7.28-.25,20.51-.06,22.6"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_78",
    "data-name": "Line 78",
    className: "cls-18",
    y2: 2.36,
    transform: "translate(76.57 256.96)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40708",
    "data-name": "Path 40708",
    className: "cls-18",
    d: "M76.18,287.3s-.8,5.3-1.06,11.78.92,20.25.92,20.25a8.236,8.236,0,0,0-.53,1.86,10.451,10.451,0,0,0,.8,2.25"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40709",
    "data-name": "Path 40709",
    className: "cls-3",
    d: "M88.89,240.16a8.727,8.727,0,0,0-.2-3.85c-.51-1.72-1.72-21.45-2.94-25.1a1.369,1.369,0,0,0-.14-.4,4.791,4.791,0,0,1-3-.21c-3.24-1.11-7.29-6.27-11.44-8.8-3.46-2.11-5.71-2-6.37-1.86-1.8,3-4.75,8.07-5.37,10.56-.91,3.65,2.43,22,2.43,22s-1.32,8.4-.91,9.21a4.654,4.654,0,0,0,1.21,1.42H87.68a10.9,10.9,0,0,0,1.21-2.97"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40710",
    "data-name": "Path 40710",
    className: "cls-18",
    d: "M88.89,240.16a8.727,8.727,0,0,0-.2-3.85c-.51-1.72-1.72-21.45-2.94-25.1a1.369,1.369,0,0,0-.14-.4,4.791,4.791,0,0,1-3-.21c-3.24-1.11-7.29-6.27-11.44-8.8-3.46-2.11-5.71-2-6.37-1.86-1.8,3-4.75,8.07-5.37,10.56-.91,3.65,2.43,22,2.43,22s-1.32,8.4-.91,9.21a4.654,4.654,0,0,0,1.21,1.42H87.68A10.9,10.9,0,0,0,88.89,240.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40711",
    "data-name": "Path 40711",
    className: "cls-6",
    d: "M85.75,211.21a1.369,1.369,0,0,0-.14-.4,4.791,4.791,0,0,1-3-.21,10.486,10.486,0,0,1-2.9-1.74H60.01a14.2,14.2,0,0,0-.57,1.64,11.962,11.962,0,0,0-.14,2.86H86.22a14.642,14.642,0,0,0-.47-2.15"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40712",
    "data-name": "Path 40712",
    className: "cls-18",
    d: "M85.75,211.21a1.369,1.369,0,0,0-.14-.4,4.791,4.791,0,0,1-3-.21,10.486,10.486,0,0,1-2.9-1.74H60.01a14.2,14.2,0,0,0-.57,1.64,11.962,11.962,0,0,0-.14,2.86H86.22A14.642,14.642,0,0,0,85.75,211.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40713",
    "data-name": "Path 40713",
    className: "cls-6",
    d: "M88.3,233.3c-.21-2.12-.47-5.09-.75-8.18H60.65c.62,4,1.22,7.32,1.22,7.32l-.13.86Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40714",
    "data-name": "Path 40714",
    className: "cls-18",
    d: "M88.3,233.3c-.21-2.12-.47-5.09-.75-8.18H60.65c.62,4,1.22,7.32,1.22,7.32l-.13.86Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40715",
    "data-name": "Path 40715",
    className: "cls-6",
    d: "M78.06,226.19s-.6-15.08-1.54-16.89-4.65-5-8.6-4.45-5.46,5.76-5.36,7.69,5.46,24.59,5.87,26,3.74,2.22,4.75,1.92,19.54-11.23,19.74-11.74-1.72-5.47-2.73-5.77-12.13,3.24-12.13,3.24"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40716",
    "data-name": "Path 40716",
    className: "cls-18",
    d: "M78.06,226.19s-.6-15.08-1.54-16.89-4.65-5-8.6-4.45-5.46,5.76-5.36,7.69,5.46,24.59,5.87,26,3.74,2.22,4.75,1.92,19.54-11.23,19.74-11.74-1.72-5.47-2.73-5.77S78.06,226.19,78.06,226.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40717",
    "data-name": "Path 40717",
    className: "cls-6",
    d: "M86.32,222l3.68-.46,4.13-2.6a36.818,36.818,0,0,1,3.93-2c.4,0,7.34.39,7.47.91s.39,1.84-.26,2.36a8.287,8.287,0,0,1-2.36.92s-.66,4.19-1.44,4.84a7.453,7.453,0,0,1-3.54.92H95.84l-2.66,2.1-2.54,3.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40718",
    "data-name": "Path 40718",
    className: "cls-18",
    d: "M86.32,222l3.68-.46,4.13-2.6a36.818,36.818,0,0,1,3.93-2c.4,0,7.34.39,7.47.91s.39,1.84-.26,2.36a8.287,8.287,0,0,1-2.36.92s-.66,4.19-1.44,4.84a7.453,7.453,0,0,1-3.54.92H95.84l-2.66,2.1-2.54,3.12Z"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_79",
    "data-name": "Line 79",
    className: "cls-18",
    x1: 4.56,
    y2: 2.43,
    transform: "translate(72.9 226.39)"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_80",
    "data-name": "Line 80",
    className: "cls-18",
    y1: 0.71,
    x2: 3.04,
    transform: "translate(72.8 226.59)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7640",
    "data-name": "Rectangle 7640",
    className: "cls-3",
    width: 37.17,
    height: 112.83,
    transform: "translate(87.98 382.48)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7641",
    "data-name": "Rectangle 7641",
    className: "cls-18",
    width: 37.17,
    height: 112.83,
    transform: "translate(87.98 382.48)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7642",
    "data-name": "Rectangle 7642",
    className: "cls-17",
    width: 37.5,
    height: 3.85,
    transform: "translate(87.98 382.48)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7643",
    "data-name": "Rectangle 7643",
    className: "cls-18",
    width: 37.5,
    height: 3.85,
    transform: "translate(87.98 382.48)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7644",
    "data-name": "Rectangle 7644",
    className: "cls-3",
    width: 63.28,
    height: 14.54,
    transform: "translate(74.93 359.64)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7645",
    "data-name": "Rectangle 7645",
    className: "cls-18",
    width: 63.28,
    height: 14.54,
    transform: "translate(74.93 359.64)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7646",
    "data-name": "Rectangle 7646",
    className: "cls-17",
    width: 63.34,
    height: 6.03,
    transform: "translate(74.86 357.68)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7647",
    "data-name": "Rectangle 7647",
    className: "cls-18",
    width: 63.34,
    height: 6.03,
    transform: "translate(74.86 357.68)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7648",
    "data-name": "Rectangle 7648",
    className: "cls-3",
    width: 44.47,
    height: 8.55,
    transform: "translate(84.34 374.18)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7649",
    "data-name": "Rectangle 7649",
    className: "cls-18",
    width: 44.47,
    height: 8.55,
    transform: "translate(84.34 374.18)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7650",
    "data-name": "Rectangle 7650",
    className: "cls-17",
    width: 43.95,
    height: 2.24,
    transform: "translate(84.34 374.18)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7651",
    "data-name": "Rectangle 7651",
    className: "cls-18",
    width: 43.95,
    height: 2.24,
    transform: "translate(84.34 374.18)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7652",
    "data-name": "Rectangle 7652",
    className: "cls-3",
    width: 37.17,
    height: 112.83,
    transform: "translate(281.83 382.48)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7653",
    "data-name": "Rectangle 7653",
    className: "cls-18",
    width: 37.17,
    height: 112.83,
    transform: "translate(281.83 382.48)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7654",
    "data-name": "Rectangle 7654",
    className: "cls-17",
    width: 37.5,
    height: 3.85,
    transform: "translate(281.83 382.48)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7655",
    "data-name": "Rectangle 7655",
    className: "cls-18",
    width: 37.5,
    height: 3.85,
    transform: "translate(281.83 382.48)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7656",
    "data-name": "Rectangle 7656",
    className: "cls-3",
    width: 63.28,
    height: 14.54,
    transform: "translate(268.78 359.64)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7657",
    "data-name": "Rectangle 7657",
    className: "cls-18",
    width: 63.28,
    height: 14.54,
    transform: "translate(268.78 359.64)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7658",
    "data-name": "Rectangle 7658",
    className: "cls-17",
    width: 63.34,
    height: 6.03,
    transform: "translate(268.71 357.68)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7659",
    "data-name": "Rectangle 7659",
    className: "cls-18",
    width: 63.34,
    height: 6.03,
    transform: "translate(268.71 357.68)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7660",
    "data-name": "Rectangle 7660",
    className: "cls-3",
    width: 44.47,
    height: 8.55,
    transform: "translate(278.19 374.18)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7661",
    "data-name": "Rectangle 7661",
    className: "cls-18",
    width: 44.47,
    height: 8.55,
    transform: "translate(278.19 374.18)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7662",
    "data-name": "Rectangle 7662",
    className: "cls-17",
    width: 43.95,
    height: 2.24,
    transform: "translate(278.19 374.18)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7663",
    "data-name": "Rectangle 7663",
    className: "cls-18",
    width: 43.95,
    height: 2.24,
    transform: "translate(278.19 374.18)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7664",
    "data-name": "Rectangle 7664",
    className: "cls-3",
    width: 376.73,
    height: 29.08,
    transform: "translate(0.5 331.56)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7665",
    "data-name": "Rectangle 7665",
    className: "cls-18",
    width: 376.73,
    height: 29.08,
    transform: "translate(0.5 331.56)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7666",
    "data-name": "Rectangle 7666",
    className: "cls-3",
    width: 37.17,
    height: 112.83,
    transform: "translate(579.81 382.48)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7667",
    "data-name": "Rectangle 7667",
    className: "cls-18",
    width: 37.17,
    height: 112.83,
    transform: "translate(579.81 382.48)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7668",
    "data-name": "Rectangle 7668",
    className: "cls-17",
    width: 37.5,
    height: 3.85,
    transform: "translate(579.81 382.48)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7669",
    "data-name": "Rectangle 7669",
    className: "cls-18",
    width: 37.5,
    height: 3.85,
    transform: "translate(579.81 382.48)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7670",
    "data-name": "Rectangle 7670",
    className: "cls-3",
    width: 63.28,
    height: 14.54,
    transform: "translate(566.75 359.64)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7671",
    "data-name": "Rectangle 7671",
    className: "cls-18",
    width: 63.28,
    height: 14.54,
    transform: "translate(566.75 359.64)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7672",
    "data-name": "Rectangle 7672",
    className: "cls-17",
    width: 63.34,
    height: 6.03,
    transform: "translate(566.68 357.68)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7673",
    "data-name": "Rectangle 7673",
    className: "cls-18",
    width: 63.34,
    height: 6.03,
    transform: "translate(566.68 357.68)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7674",
    "data-name": "Rectangle 7674",
    className: "cls-3",
    width: 44.47,
    height: 8.55,
    transform: "translate(576.16 374.18)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7675",
    "data-name": "Rectangle 7675",
    className: "cls-18",
    width: 44.47,
    height: 8.55,
    transform: "translate(576.16 374.18)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7676",
    "data-name": "Rectangle 7676",
    className: "cls-17",
    width: 43.95,
    height: 2.24,
    transform: "translate(576.16 374.18)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7677",
    "data-name": "Rectangle 7677",
    className: "cls-18",
    width: 43.95,
    height: 2.24,
    transform: "translate(576.16 374.18)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7678",
    "data-name": "Rectangle 7678",
    className: "cls-3",
    width: 227.16,
    height: 29.08,
    transform: "translate(523.47 331.56)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7679",
    "data-name": "Rectangle 7679",
    className: "cls-18",
    width: 227.16,
    height: 29.08,
    transform: "translate(523.47 331.56)"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBridgeImg);
export default __webpack_public_path__ + "static/media/bridge_Img.bd08e849ddc1349aa1369e91a2952565.svg";
export { ForwardRef as ReactComponent };